
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("dKe2f", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $7232b894022e706d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5BRby = parcelRequire("5BRby");

var $cA8OV = parcelRequire("cA8OV");

var $5GxEP = parcelRequire("5GxEP");

var $lawuT = parcelRequire("lawuT");

var $bSS3k = parcelRequire("bSS3k");

var $2Kayt = parcelRequire("2Kayt");
let $7232b894022e706d$var$counter = 0;
class $7232b894022e706d$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    constructor(props){
        super(props);
        this.store = props.store ?? (0, $lawuT.store);
    }
    componentDidMount() {
        $7232b894022e706d$var$counter += 1;
        if ($7232b894022e706d$var$counter > 1) throw new Error('Invalid state: Two flag applications mounted at the same time.');
    }
    componentWillUnmount() {
        $7232b894022e706d$var$counter -= 1;
        this.store.dispatch((0, $bSS3k.reset)());
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5GxEP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5BRby.default), {
            store: this.store
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cA8OV.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2Kayt.default), null))));
    }
}

});
parcelRegister("cA8OV", function(module, exports) {

$parcel$export(module.exports, "default", () => $0809371ccd3c77a9$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/styled-components-migration, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $kwce8 = parcelRequire("kwce8");

var $c9TLT = parcelRequire("c9TLT");
var // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
$0809371ccd3c77a9$export$2e2bcd8739ae039 = (0, $kwce8.default).div.withConfig({
    componentId: "h5xpn2-0"
})({
    fontFamily: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $c9TLT.fontFamily,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: `${(0, $c9TLT.fontSize)}px`,
    height: 'inherit',
    letterSpacing: 'normal'
});

});
parcelRegister("c9TLT", function(module, exports) {

$parcel$export(module.exports, "gridSize", () => $d7c0be4143e494a4$export$6d8204c2cb2e06b8);
$parcel$export(module.exports, "borderRadius", () => $d7c0be4143e494a4$export$7a57f79000377ca2);
$parcel$export(module.exports, "fontSize", () => $d7c0be4143e494a4$export$85e3c3ca0c6fb93);
$parcel$export(module.exports, "fontFamily", () => $d7c0be4143e494a4$export$a5975749f0374264);
$parcel$export(module.exports, "codeFontFamily", () => $d7c0be4143e494a4$export$356129969ee49c55);
$parcel$export(module.exports, "contentHorizontalSpacing", () => $d7c0be4143e494a4$export$22dec01f2c854397);
$parcel$export(module.exports, "layers", () => $d7c0be4143e494a4$export$7be255094ccdc533);
$parcel$export(module.exports, "layout", () => $d7c0be4143e494a4$export$b3219800bda33a1f);

var $lcnyw = parcelRequire("lcnyw");
const $d7c0be4143e494a4$export$6d8204c2cb2e06b8 = (0, $lcnyw.gridSize)();
const $d7c0be4143e494a4$export$7a57f79000377ca2 = (0, $lcnyw.borderRadius)();
const $d7c0be4143e494a4$export$85e3c3ca0c6fb93 = (0, $lcnyw.fontSize)();
const $d7c0be4143e494a4$export$a5975749f0374264 = (0, $lcnyw.fontFamily)();
const $d7c0be4143e494a4$export$356129969ee49c55 = (0, $lcnyw.codeFontFamily)();
const $d7c0be4143e494a4$export$22dec01f2c854397 = 40;
const $d7c0be4143e494a4$export$dab5ea164c6f81a = 100;
const $d7c0be4143e494a4$export$7be255094ccdc533 = {
    banner: (0, $lcnyw.layers).navigation(),
    card: (0, $lcnyw.layers).card(),
    dialog: (0, $lcnyw.layers).dialog(),
    navigation: (0, $lcnyw.layers).navigation(),
    // left sidebar overrides the bottom shadow of navigation without this
    leftSidebar: (0, $lcnyw.layers).navigation() - 1,
    // right sidebar shows on top of navigation elements without this
    rightSidebar: (0, $lcnyw.layers).navigation() - 1,
    layer: (0, $lcnyw.layers).layer(),
    blanket: (0, $lcnyw.layers).blanket(),
    modal: (0, $lcnyw.layers).modal(),
    flag: (0, $lcnyw.layers).flag(),
    spotlight: (0, $lcnyw.layers).spotlight(),
    tooltip: (0, $lcnyw.layers).tooltip(),
    mobileBanner: $d7c0be4143e494a4$export$dab5ea164c6f81a
};
const $d7c0be4143e494a4$export$b3219800bda33a1f = {
    issueIconSize: $d7c0be4143e494a4$export$6d8204c2cb2e06b8 * 2
};

});


parcelRegister("2Kayt", function(module, exports) {

$parcel$export(module.exports, "default", () => $44e99bca81cc042f$export$2e2bcd8739ae039);

var $bSS3k = parcelRequire("bSS3k");

var $2CS8g = parcelRequire("2CS8g");

var $lNNXV = parcelRequire("lNNXV");

var $gCnOc = parcelRequire("gCnOc");

var $d9san = parcelRequire("d9san");
var $44e99bca81cc042f$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((state)=>({
        flags: (0, $2CS8g.getFlags)(state),
        PropBypass: $d9san.PropBypass
    }), {
    onDismissed: (0, $bSS3k.dismiss)
})((0, $gCnOc.default));

});
parcelRegister("2CS8g", function(module, exports) {

$parcel$export(module.exports, "getFlags", () => $69569efc8ba5bccf$export$d5815430bcc75df0);
const $69569efc8ba5bccf$export$d5815430bcc75df0 = (state)=>state.flags;

});

parcelRegister("gCnOc", function(module, exports) {

$parcel$export(module.exports, "default", () => $132965d7b936abb5$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5Yqat = parcelRequire("5Yqat");

var $4ZYEI = parcelRequire("4ZYEI");

var $gUUjF = parcelRequire("gUUjF");

var $ihlUj = parcelRequire("ihlUj");

var $1YNHg = parcelRequire("1YNHg");

var $c8KxL = parcelRequire("c8KxL");

var $giAhk = parcelRequire("giAhk");

var $8WuJm = parcelRequire("8WuJm");
/**
 * Manages and renders flag notifications, supporting dynamic appearances and behaviors. Incorporates
 * internationalization for adaptable message formatting and handles user interactions through
 * configurable actions. Designed to display transient, informative messages to users in a visually
 * consistent manner.
 */ // eslint-disable-next-line jira/react/no-class-components
class $132965d7b936abb5$var$Flags extends (0, $eUqFw.Component) {
    formatMessage(message) {
        const { intl: { formatMessage: formatMessage } } = this.props;
        if (Array.isArray(message)) return formatMessage(...message);
        if ((0, (/*@__PURE__*/$parcel$interopDefault($4ZYEI)))(message)) return String(message);
        return formatMessage(message);
    }
    formatActions(actions) {
        return actions ? actions.map((action)=>({
                onClick: action.onClick,
                content: this.formatMessage(action.content),
                href: action.href,
                target: action.target
            })) : undefined;
    }
    renderConfigurableFlag(id, flagConfiguration) {
        const { type: type, title: title, description: description, isAutoDismiss: isAutoDismiss, actions: actions, appearance: appearance, testId: testId, error: error, icon: icon, onDismissed: onDismissed, delayAnnouncement: delayAnnouncement, messageId: messageId, messageType: messageType } = flagConfiguration;
        const defaultedIsAutoDismiss = isAutoDismiss === undefined ? type === 'success' || type === 'info' : isAutoDismiss;
        const isValidType = [
            'success',
            'error',
            'info',
            'warning'
        ].includes(type);
        let formattedDescription = description && this.formatMessage(description);
        if (error) // @ts-expect-error - TS2322 - Type 'Element' is not assignable to type 'string'.
        formattedDescription = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, formattedDescription), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ihlUj.ErrorHash), {
            error: error
        }));
        if (isValidType) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1YNHg.JiraCommonFlag), {
            key: id,
            id: id,
            flagType: type,
            icon: icon,
            title: this.formatMessage(title),
            description: formattedDescription,
            isAutoDismiss: defaultedIsAutoDismiss,
            actions: this.formatActions(actions),
            appearance: appearance,
            testId: testId,
            onDismissed: onDismissed,
            messageId: messageId,
            messageType: messageType,
            ...delayAnnouncement && {
                delayAnnouncement: delayAnnouncement
            }
        });
        return null;
    }
    render() {
        const { flags: flags, onDismissed: onDismissed } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
            sourceName: "flag",
            sourceType: (0, $41ea3621645e2acc$export$1171103ea9083ffa)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c8KxL.default), {
            onDismissed: onDismissed
        }, (0, (/*@__PURE__*/$parcel$interopDefault($5Yqat)))(flags.map((flagInstance)=>{
            const { id: id, flag: flag } = flagInstance;
            // @ts-expect-error - TS2339 - Property 'render' does not exist on type 'Flag'.
            if (flag.render !== undefined) {
                // @ts-expect-error - TS2322 - Type 'Flag' is not assignable to type 'FlagCustom'.
                const flagCustom = flag;
                return flagCustom.render({
                    key: id
                });
            }
            // @ts-expect-error - TS2339 - Property 'type' does not exist on type 'Flag'.
            if (flag.type !== undefined) {
                // @ts-expect-error - TS2322 - Type 'Flag' is not assignable to type 'FlagConfiguration'.
                const flagConfiguration = flag;
                const comp = this.renderConfigurableFlag(id, flagConfiguration);
                if (comp) return comp;
                (0, $gUUjF.default).safeErrorWithoutCustomerData('flags.view', `There was a problem rendering a flag of type: ${flagConfiguration.type}`);
                return null;
            }
            // @ts-expect-error - TS2322 - Type 'Flag' is not assignable to type 'FlagComponent'.
            const FlagComponent = flag;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(FlagComponent, {
                key: id,
                id: id,
                onDismissed: onDismissed
            });
        }))));
    }
}
var $132965d7b936abb5$export$2e2bcd8739ae039 = (0, $giAhk.injectIntlV2)($132965d7b936abb5$var$Flags);

});
parcelRegister("5Yqat", function(module, exports) {
/**
 * Creates an array with all falsey values removed. The values `false`, `null`,
 * `0`, `""`, `undefined`, and `NaN` are falsey.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to compact.
 * @returns {Array} Returns the new array of filtered values.
 * @example
 *
 * _.compact([0, 1, false, 2, '', 3]);
 * // => [1, 2, 3]
 */ function $4596dac18914dac8$var$compact(array) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (value) result[resIndex++] = value;
    }
    return result;
}
module.exports = $4596dac18914dac8$var$compact;

});

parcelRegister("4ZYEI", function(module, exports) {

var $2OY5s = parcelRequire("2OY5s");

var $1c8hB = parcelRequire("1c8hB");

var $hYEMs = parcelRequire("hYEMs");
/** `Object#toString` result references. */ var $3a3be8dd1917bddc$var$stringTag = '[object String]';
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function $3a3be8dd1917bddc$var$isString(value) {
    return typeof value == 'string' || !$1c8hB(value) && $hYEMs(value) && $2OY5s(value) == $3a3be8dd1917bddc$var$stringTag;
}
module.exports = $3a3be8dd1917bddc$var$isString;

});

parcelRegister("ihlUj", function(module, exports) {

$parcel$export(module.exports, "ErrorHash", () => $e823e2ae3cb86cca$export$db1607d938d7ca33);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $dnJL9 = parcelRequire("dnJL9");

var $d6f6c = parcelRequire("d6f6c");

var $iH6c1 = parcelRequire("iH6c1");

var $24diY = parcelRequire("24diY");
const $e823e2ae3cb86cca$var$wrapperStyles = null;
const $e823e2ae3cb86cca$var$OldErrorHash = ({ error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        role: "note"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            "_1e0c1o8l _18s8qssn _1yt4u49m _11q710p6 _2rko1l7b _ect41u0j _1wyb1vlj _syaz1rr7"
        ])
    }, "ERROR: ", (0, $iH6c1.getErrorHash)(error)));
const $e823e2ae3cb86cca$var$NewErrorHash = ({ error: error })=>{
    const source = `Hash ${(0, $iH6c1.getErrorHash)(error)}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireOperationalAnalytics), {
        action: "rendered",
        actionSubject: "errorHash"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        role: "note"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $24diY.CodeBlockWithCopyButton), {
        source: source,
        copyCodeActionSubjectId: "copyErrorHash"
    })));
};
const $e823e2ae3cb86cca$export$db1607d938d7ca33 = (0, $dnJL9.componentWithFG)('trace_id_in_jira_error_flag_and_page', $e823e2ae3cb86cca$var$NewErrorHash, $e823e2ae3cb86cca$var$OldErrorHash);

});
parcelRegister("dnJL9", function(module, exports) {

$parcel$export(module.exports, "componentWithFG", () => $dcea2fa8766d9cd0$export$cf56d0f54cfcce4);

var $9zysr = parcelRequire("9zysr");

var $eI5EY = parcelRequire("eI5EY");
const $dcea2fa8766d9cd0$export$cf56d0f54cfcce4 = (gateName, ComponentTrue, ComponentFalse)=>(0, $9zysr.componentWithCondition)(()=>(0, $eI5EY.fg)(gateName), ComponentTrue, ComponentFalse);

});

parcelRegister("d6f6c", function(module, exports) {

$parcel$export(module.exports, "FireUiAnalytics", () => $6c42ad247d2b6151$export$5a67e7291fd4569e);
$parcel$export(module.exports, "FireTrackAnalytics", () => $6c42ad247d2b6151$export$5f0d7aae8dfa8b86);
$parcel$export(module.exports, "FireOperationalAnalytics", () => $6c42ad247d2b6151$export$b71c3ada5d4ec5da);
$parcel$export(module.exports, "FireScreenAnalytics", () => $6c42ad247d2b6151$export$2ccf161b817b43b);

var $eUqFw = parcelRequire("eUqFw");

var $2jDha = parcelRequire("2jDha");


var $jMP2a = parcelRequire("jMP2a");
// eslint-disable-next-line jira/react/no-class-components
class $6c42ad247d2b6151$var$FireComponent extends (0, $eUqFw.Component) {
    componentDidMount() {
        const { type: type, attributes: attributes, eventName: eventName, componentName: componentName, action: actionProps, actionSubject: actionSubjectProps, actionSubjectId: actionSubjectIdProps } = this.props;
        if (eventName && (actionProps || actionSubjectProps)) throw Error('eventName is an alias for action & actionSubject, provide only one of those');
        if (componentName && actionSubjectIdProps) throw Error('componentName is an alias for actionSubjectId, provide only one of those');
        const eventNameSplit = eventName ? eventName.split(' ') : [];
        const action = actionProps || eventNameSplit[1];
        const actionSubject = actionSubjectProps || eventNameSplit[0];
        if (!action || !actionSubject) throw Error('eventName should exist and be in the format "subject action", i.e. "button clicked", "menu opened", "issue created", etc');
        const actionSubjectId = actionSubjectIdProps || componentName;
        const analyticsEvent = this.props.createAnalyticsEvent({
            action: action
        });
        (0, $jMP2a.fireAnalytics)(analyticsEvent, type, {
            action: action,
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            attributes: attributes
        });
    }
    render() {
        return null;
    }
}
const $6c42ad247d2b6151$export$64eb47d7b94ba089 = (0, $2jDha.default)()($6c42ad247d2b6151$var$FireComponent);
const $6c42ad247d2b6151$export$5a67e7291fd4569e = (props)=>// @ts-expect-error - TS2322 - Type '{ type: "UI"; attributes?: { [key: string]: any; } | undefined; eventName?: string | undefined; componentName?: string | undefined; action?: string | undefined; actionSubject?: string | undefined; actionSubjectId?: string | undefined; }' is not assignable to type 'IntrinsicAttributes & Pick<WithAnalyticsEventsProps, never> & RefAttributes<any>'.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6c42ad247d2b6151$export$64eb47d7b94ba089, {
        ...props,
        type: (0, $41ea3621645e2acc$export$a1562d08625f5d7e)
    });
const $6c42ad247d2b6151$export$5f0d7aae8dfa8b86 = (props)=>// @ts-expect-error - TS2322 - Type '{ type: "TRACK"; attributes?: { [key: string]: any; } | undefined; eventName?: string | undefined; componentName?: string | undefined; action?: string | undefined; actionSubject?: string | undefined; actionSubjectId?: string | undefined; }' is not assignable to type 'IntrinsicAttributes & Pick<WithAnalyticsEventsProps, never> & RefAttributes<any>'.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6c42ad247d2b6151$export$64eb47d7b94ba089, {
        ...props,
        type: (0, $41ea3621645e2acc$export$947dac6c72b26f81)
    });
const $6c42ad247d2b6151$export$b71c3ada5d4ec5da = (props)=>// @ts-expect-error - TS2322 - Type '{ type: "OPERATIONAL"; attributes?: { [key: string]: any; } | undefined; eventName?: string | undefined; componentName?: string | undefined; action?: string | undefined; actionSubject?: string | undefined; actionSubjectId?: string | undefined; }' is not assignable to type 'IntrinsicAttributes & Pick<WithAnalyticsEventsProps, never> & RefAttributes<any>'.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6c42ad247d2b6151$export$64eb47d7b94ba089, {
        ...props,
        type: (0, $41ea3621645e2acc$export$12346a674644c156)
    });
const $6c42ad247d2b6151$export$2ccf161b817b43b = (props)=>// @ts-expect-error - TS2322 - Type '{ type: "SCREEN"; eventName: string; attributes?: { [key: string]: any; } | undefined; componentName?: string | undefined; action?: string | undefined; actionSubject?: string | undefined; actionSubjectId?: string | undefined; }' is not assignable to type 'IntrinsicAttributes & Pick<WithAnalyticsEventsProps, never> & RefAttributes<any>'.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6c42ad247d2b6151$export$64eb47d7b94ba089, {
        ...props,
        type: (0, $41ea3621645e2acc$export$f1d537d508d2945a),
        eventName: "screen viewed"
    });

});
// SCREENS
const $41ea3621645e2acc$export$f636b5b56f1d624a = 'Screen';
const $41ea3621645e2acc$export$9d2de6eebf7462b5 = 'Drawer';
const $41ea3621645e2acc$export$1171103ea9083ffa = 'Modal';
const $41ea3621645e2acc$export$cae2783c9279926 = 'InlineDialog';
const $41ea3621645e2acc$export$d1123261ca8831d2 = 'Dropdown';
const $41ea3621645e2acc$export$238d30785c4bca84 = 'Banner';
const $41ea3621645e2acc$export$a1562d08625f5d7e = 'UI';
const $41ea3621645e2acc$export$947dac6c72b26f81 = 'TRACK';
const $41ea3621645e2acc$export$f1d537d508d2945a = 'SCREEN';
const $41ea3621645e2acc$export$12346a674644c156 = 'OPERATIONAL';


parcelRegister("24diY", function(module, exports) {

$parcel$export(module.exports, "CodeBlockWithCopyButton", () => $3a3e908650260d73$export$ced1fc74d907d387);

var $eUqFw = parcelRequire("eUqFw");

var $5mbBR = parcelRequire("5mbBR");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $1jreh = parcelRequire("1jreh");
const $3a3e908650260d73$export$ced1fc74d907d387 = ({ source: source, copyCodeActionSubjectId: copyCodeActionSubjectId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $3a3e908650260d73$var$wrapperStyles,
        role: "region"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1jreh.ActionContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1jreh.CopyAction), {
        source: source,
        actionSubjectId: copyCodeActionSubjectId
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5mbBR.default), {
        text: source,
        showLineNumbers: false,
        shouldWrapLongLines: false
    })));
const $3a3e908650260d73$var$wrapperStyles = (0, $1ZAYh.xcss)({
    width: '100%',
    position: 'relative'
});

});
parcelRegister("5mbBR", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3c647505c043710$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $eXFKf = parcelRequire("eXFKf");

var $gamSa = parcelRequire("gamSa");

var $4BdAI = parcelRequire("4BdAI");

var $dvVZk = parcelRequire("dvVZk");
/**
 * __Code block__
 *
 * A code block highlights an entire block of code and keeps the formatting.
 *
 * - [Examples](https://atlassian.design/components/code/code-block/examples)
 * - [Code](https://atlassian.design/components/code/code-block/code)
 * - [Usage](https://atlassian.design/components/code/code-block/usage)
 */ const $a3c647505c043710$var$CodeBlock = /*#__PURE__*/ (0, $eUqFw.memo)(function CodeBlock({ showLineNumbers: showLineNumbers = true, firstLineNumber: firstLineNumber = 1, language: providedLanguage = 'text', highlight: highlight = '', highlightedStartText: highlightedStartText = 'Highlight start', highlightedEndText: highlightedEndText = 'Highlight end', testId: testId, text: text, codeBidiWarnings: codeBidiWarnings = true, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled = true, shouldWrapLongLines: shouldWrapLongLines = false }) {
    const numLines = (text || '').split('\n').length + (firstLineNumber > 0 ? firstLineNumber : 1) - 1;
    const theme = (0, $eUqFw.useMemo)(()=>(0, $gamSa.getCodeBlockTheme)(numLines), [
        numLines
    ]);
    const getStyles = (0, $eUqFw.useMemo)(()=>(0, $gamSa.getCodeBlockStyles)(theme), [
        theme
    ]);
    const styles = (0, $eUqFw.useMemo)(()=>/*#__PURE__*/ (0, $byn9U.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        getStyles(highlightedStartText, highlightedEndText, showLineNumbers, shouldWrapLongLines)), [
        highlightedStartText,
        highlightedEndText,
        showLineNumbers,
        shouldWrapLongLines,
        getStyles
    ]);
    const { getHighlightStyles: getHighlightStyles, highlightedLines: highlightedLines } = (0, $eXFKf.useHighlightLines)({
        highlight: highlight,
        testId: testId
    });
    const getLineProps = (0, $eUqFw.useCallback)((line)=>getHighlightStyles(line, highlightedLines), [
        getHighlightStyles,
        highlightedLines
    ]);
    const language = (0, $eUqFw.useMemo)(()=>(0, $4BdAI.normalizeLanguage)(providedLanguage), [
        providedLanguage
    ]);
    // https://product-fabric.atlassian.net/browse/DST-2472
    const languageToUse = text ? language : 'text';
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $dvVZk.default), {
        "data-code-lang": language,
        "data-ds--code--code-block": "",
        testId: testId,
        language: languageToUse,
        css: styles,
        showLineNumbers: showLineNumbers,
        firstLineNumber: firstLineNumber,
        lineProps: getLineProps,
        // shouldCreateParentElementForLines is needed to pass down props to each line.
        // This is necessary for both line highlighting and testId's, as each of
        // these rely on a data attribute being passed down to lines.
        shouldCreateParentElementForLines: highlight.length > 0 || !!testId,
        shouldWrapLongLines: shouldWrapLongLines,
        codeBidiWarnings: codeBidiWarnings,
        codeBidiWarningLabel: codeBidiWarningLabel,
        codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled,
        text: text
    });
});
$a3c647505c043710$var$CodeBlock.displayName = 'CodeBlock';
var $a3c647505c043710$export$2e2bcd8739ae039 = $a3c647505c043710$var$CodeBlock;

});
parcelRegister("eXFKf", function(module, exports) {

$parcel$export(module.exports, "useHighlightLines", () => $364350d9593670f6$export$84415a200bdf33ed);

var $eUqFw = parcelRequire("eUqFw");
const $364350d9593670f6$var$DEFAULT_LINE_EL_ATTR_OBJ = {
    'data-ds--code--row': ''
};
const $364350d9593670f6$var$getLineStyleObject = (lineNumber, testId)=>{
    return testId ? {
        'data-testid': `${testId}-line-${lineNumber}`,
        ...$364350d9593670f6$var$DEFAULT_LINE_EL_ATTR_OBJ
    } : $364350d9593670f6$var$DEFAULT_LINE_EL_ATTR_OBJ;
};
const $364350d9593670f6$export$84415a200bdf33ed = ({ highlight: highlight = '', testId: testId })=>{
    const highlightedLines = (0, $eUqFw.useMemo)(()=>{
        if (!highlight) return [];
        return highlight.split(',').map((num)=>{
            if (num.indexOf('-') > 0) {
                // We found a line group, e.g. 1-3
                const [from, to] = num.split('-').map(Number)// Sort by lowest value first, highest value last.
                .sort((a, b)=>a - b);
                return Array(to + 1).fill(undefined).map((_, index)=>index).slice(from, to + 1);
            }
            return Number(num);
        }).reduce((acc, val)=>acc.concat(val), []) || [];
    }, [
        highlight
    ]);
    const getHighlightStyles = (0, $eUqFw.useCallback)((lineNumber, highlightedLines)=>{
        if (!highlight || highlightedLines.length === 0) return $364350d9593670f6$var$getLineStyleObject(lineNumber, testId);
        if (highlightedLines.includes(lineNumber)) {
            const highlightedDataAttrObj = {
                'data-ds--code--row--highlight': ''
            };
            return {
                ...highlightedDataAttrObj,
                ...$364350d9593670f6$var$getLineStyleObject(lineNumber, testId)
            };
        }
        return $364350d9593670f6$var$getLineStyleObject(lineNumber, testId);
    }, [
        highlight,
        testId
    ]);
    return {
        getHighlightStyles: getHighlightStyles,
        highlightedLines: highlightedLines
    };
};

});

parcelRegister("gamSa", function(module, exports) {

$parcel$export(module.exports, "getCodeBlockStyles", () => $9564a2d27c68447a$export$b571c24d82780698);
$parcel$export(module.exports, "getCodeStyles", () => $9564a2d27c68447a$export$d5fcf1b7ff23707b);
$parcel$export(module.exports, "getCodeBlockTheme", () => $9564a2d27c68447a$export$57a2d4b573afd64a);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $iUo9q = parcelRequire("iUo9q");

var $bQ0Ef = parcelRequire("bQ0Ef");
const $9564a2d27c68447a$export$cb7aec0206b595d2 = (numLines)=>{
    if (!numLines) return '1ch';
    return `${numLines.toFixed(0).length}ch`;
};
const $9564a2d27c68447a$var$lineNumberStyle = (theme)=>({
        // width of the line number gutter
        minWidth: `calc(${theme.lineNumberWidth} + ${0, $iUo9q.LINE_NUMBER_GUTTER}px) !important`,
        // this needs to be important or it gets overwritten by inline styles
        fontStyle: 'normal !important',
        // this needs to be important or it gets overwritten by inline styles
        color: `${theme.lineNumberColor} !important`,
        flexShrink: 0,
        // needed to replicate existing design spec
        boxSizing: 'border-box',
        paddingRight: `${0, $iUo9q.SPACING}px !important`,
        paddingLeft: (0, $iUo9q.SPACING),
        marginRight: (0, $iUo9q.SPACING),
        textAlign: 'right',
        userSelect: 'none',
        // this is to fix SSR spacing issue
        display: 'block',
        // This is how we are preventing line numbers being copied to clipboard.
        // (`user-select: none;` was not sufficent).
        // https://product-fabric.atlassian.net/browse/DSP-2729
        '&::after': {
            content: `attr(data-ds--line-number)`
        }
    });
// order of these keys does matter as it will affect the css precedence
const $9564a2d27c68447a$var$syntaxKeywordColors = (theme)=>({
        '.token': {
            // this specifically stops prism css cascading.
            '&:not([class=token],[data-ds--code--row--highlight],[data-ds--code--row])': {
                all: 'unset'
            },
            // additional specificity required to match the all: unset
            '&.key,&.keyword': {
                color: theme.keywordColor,
                fontWeight: 'bolder'
            },
            '&.attr-name': {
                color: theme.attributeColor
            },
            '&.selector': {
                color: theme.selectorTagColor
            },
            '&.comment,&.block-comment': {
                color: theme.commentColor,
                fontFamily: theme.fontFamilyItalic,
                fontStyle: 'italic'
            },
            '&.function-name': {
                color: theme.sectionColor
            },
            '&.doctype': {
                color: theme.docTagColor
            },
            '&.substr': {
                color: theme.substringColor
            },
            '&.namespace': {
                color: theme.nameColor
            },
            '&.builtin': {
                color: theme.builtInColor
            },
            '&.entity': {
                color: theme.literalColor
            },
            '&.bullet': {
                color: theme.bulletColor
            },
            '&.code': {
                color: theme.codeColor
            },
            '&.regex': {
                color: theme.regexpColor
            },
            '&.symbol': {
                color: theme.symbolColor
            },
            '&.variable': {
                color: theme.variableColor
            },
            '&.url': {
                color: theme.linkColor
            },
            '&.selector-attr': {
                color: theme.selectorAttributeColor
            },
            '&.selector-pseudo': {
                color: theme.selectorPseudoColor
            },
            '&.type': {
                color: theme.typeColor
            },
            '&.quote': {
                color: theme.quoteColor
            },
            '&.tag': {
                color: theme.templateTagColor
            },
            '&.string': {
                color: theme.stringColor
            },
            '&.class-name': {
                color: theme.sectionColor
            },
            '&.title': {
                color: theme.titleColor
            },
            '&.section': {
                color: theme.sectionColor
            },
            '&.meta-keyword': {
                color: theme.metaKeywordColor
            },
            '&.meta': {
                color: theme.metaColor
            },
            '&.italic': {
                fontStyle: 'italic'
            },
            '&.bold': {
                fontWeight: 'bolder'
            },
            '&.function': {
                color: theme.functionColor
            },
            '&.number': {
                color: theme.numberColor
            },
            '&.attr-value': {
                color: theme.attributeColor
            },
            '&.prolog': {
                color: theme.prologColor
            },
            '&.cdata': {
                color: theme.cdataColor
            },
            '&.punctuation': {
                color: theme.punctuationColor
            },
            '&.property': {
                color: theme.propertyColor
            },
            '&.constant': {
                color: theme.constantColor
            },
            '&.deleted': {
                color: theme.deletedColor
            },
            '&.boolean': {
                color: theme.booleanColor
            },
            '&.char': {
                color: theme.charColor
            },
            '&.inserted': {
                color: theme.insertedColor
            },
            '&.operator': {
                color: theme.operatorColor
            },
            '&.atrule': {
                color: theme.atruleColor
            },
            '&.important': {
                color: theme.importantColor,
                fontWeight: 'bold'
            }
        }
    });
const $9564a2d27c68447a$export$ee58a26b5d612ac1 = (theme)=>({
        fontSize: (0, $iUo9q.CODE_FONT_SIZE),
        fontFamily: theme.fontFamily,
        fontWeight: 'normal',
        backgroundColor: `var(${0, $iUo9q.VAR_CODE_BG_COLOR},${theme.backgroundColor})`,
        color: theme.textColor,
        borderStyle: 'none',
        borderRadius: "var(--ds-border-radius, 3px)"
    });
const $9564a2d27c68447a$export$b571c24d82780698 = (theme)=>(highlightedStartText, highlightedEndText, showLineNumbers, shouldWrapLongLines)=>({
            // this is required to account for prismjs styles leaking into the codeblock
            'code[class*="language-"], pre[class*="language-"], code': {
                all: 'unset',
                padding: showLineNumbers ? `${0, $iUo9q.SPACING}px 0` : (0, $iUo9q.SPACING),
                tabSize: 4
            },
            display: 'flex',
            lineHeight: (0, $iUo9q.CODE_LINE_HEIGHT),
            overflowX: 'auto',
            whiteSpace: 'pre',
            direction: 'ltr',
            ...$9564a2d27c68447a$export$ee58a26b5d612ac1(theme),
            ...$9564a2d27c68447a$var$syntaxKeywordColors(theme),
            // this is to account for SSR spacing issue once loaded in browser
            '& .linenumber, .ds-sh-line-number': $9564a2d27c68447a$var$lineNumberStyle(theme),
            '& .linenumber': {
                display: 'inline-block !important',
                float: 'left'
            },
            // these styles are for line highlighting
            '& [data-ds--code--row]': {
                display: showLineNumbers ? 'flex' : 'block',
                paddingRight: `${0, $iUo9q.SPACING}px !important`,
                marginRight: `-${0, $iUo9q.SPACING}px`
            },
            '& [data-ds--code--row--highlight]': {
                background: `${theme.highlightedLineBgColor}`,
                // eslint-disable-next-line @atlaskit/design-system/use-visually-hidden
                '&::before, &::after': {
                    clipPath: 'inset(100%)',
                    clip: 'rect(1px, 1px, 1px, 1px)',
                    height: '1px',
                    overflow: 'hidden',
                    position: 'absolute',
                    whiteSpace: 'nowrap',
                    width: '1px'
                },
                // The formatting here is an accessibility convention
                '&::before': {
                    content: `" [${highlightedStartText}] "`
                },
                '&::after': {
                    content: `" [${highlightedEndText}] "`
                }
            },
            '& [data-ds--code--row--highlight] .linenumber': {
                borderLeft: `${0, $iUo9q.HIGHLIGHT_BORDER_WIDTH} solid ${theme.highlightedLineBorderColor}`,
                paddingLeft: `${(0, $iUo9q.SPACING) / 2}px !important`,
                position: 'relative'
            },
            // fill in space caused by parent border top
            '& [data-ds--code--row--highlight] .linenumber::before': {
                content: '""',
                position: 'absolute',
                width: (0, $iUo9q.HIGHLIGHT_BORDER_WIDTH),
                top: '-1px',
                left: `-${0, $iUo9q.HIGHLIGHT_BORDER_WIDTH}`,
                borderTop: `1px solid ${theme.highlightedLineBorderColor}`
            },
            '[data-ds--code--row--highlight] + [data-ds--code--row]:not([data-ds--code--row--highlight]), [data-ds--code--row]:not([data-ds--code--row--highlight]) + [data-ds--code--row--highlight]': {
                borderTop: '1px dashed transparent'
            },
            '[data-ds--code--row--highlight]:last-child': {
                borderBottom: '1px dashed transparent'
            },
            '& code:first-of-type': {
                paddingRight: `0px !important`,
                backgroundImage: showLineNumbers ? `linear-gradient(to right, var(${0, $iUo9q.VAR_CODE_LINE_NUMBER_BG_COLOR},${theme.lineNumberBgColor}), var(${0, $iUo9q.VAR_CODE_LINE_NUMBER_BG_COLOR},${theme.lineNumberBgColor})
    calc(${theme.lineNumberWidth} + ${0, $iUo9q.LINE_NUMBER_GUTTER}px), transparent calc(${theme.lineNumberWidth} + ${0, $iUo9q.LINE_NUMBER_GUTTER}px), transparent)` : undefined
            },
            // we need to use last-of-type because when Code is SSR'd
            // 2 <code> elements are created and we don't want this style
            // applied to the first one
            '& code:last-of-type': {
                paddingRight: `${0, $iUo9q.SPACING}px !important`,
                flexBasis: 'auto',
                flexGrow: 1,
                // Needed for the highlight line to extend full-width
                flexShrink: shouldWrapLongLines ? 1 : 0,
                wordBreak: 'break-word'
            },
            // Prevents empty code blocks from vertically collapsing
            'code > span:only-child:empty:before, code > span:only-child > span:only-child:empty:before': {
                content: '" "'
            }
        });
const $9564a2d27c68447a$export$d5fcf1b7ff23707b = ()=>{
    const theme = (0, $bQ0Ef.getBaseTheme)();
    const baseStyles = $9564a2d27c68447a$export$ee58a26b5d612ac1(theme);
    return {
        ...baseStyles,
        display: 'inline',
        padding: '2px 0.5ch',
        boxDecorationBreak: 'clone',
        fontSize: '0.875em',
        overflow: 'auto',
        overflowWrap: 'break-word',
        whiteSpace: 'pre-wrap'
    };
};
const $9564a2d27c68447a$export$57a2d4b573afd64a = (maxLines)=>{
    return {
        ...(0, $bQ0Ef.getBaseTheme)(),
        ...(0, $bQ0Ef.getColorPalette)(),
        lineNumberWidth: maxLines ? $9564a2d27c68447a$export$cb7aec0206b595d2(maxLines) : undefined
    };
};

});
parcelRegister("iUo9q", function(module, exports) {

$parcel$export(module.exports, "CODE_FONT_SIZE", () => $fb842dc45fcee8c3$export$431ac46d758d98c8);
$parcel$export(module.exports, "CODE_LINE_HEIGHT", () => $fb842dc45fcee8c3$export$8e3c04032121c606);
$parcel$export(module.exports, "HIGHLIGHT_BORDER_WIDTH", () => $fb842dc45fcee8c3$export$c8b5dc30e9f2b86e);
$parcel$export(module.exports, "SPACING", () => $fb842dc45fcee8c3$export$82ea42e772d49e5b);
$parcel$export(module.exports, "LINE_NUMBER_GUTTER", () => $fb842dc45fcee8c3$export$eeeea0ff98e06fff);
$parcel$export(module.exports, "VAR_CODE_LINE_NUMBER_BG_COLOR", () => $fb842dc45fcee8c3$export$254015fe817dcb9e);
$parcel$export(module.exports, "VAR_CODE_BG_COLOR", () => $fb842dc45fcee8c3$export$1758fda69688282e);
// eslint-disable-next-line @atlaskit/design-system/no-deprecated-imports

var $lcnyw = parcelRequire("lcnyw");
const $fb842dc45fcee8c3$export$431ac46d758d98c8 = 12;
const $fb842dc45fcee8c3$export$8e3c04032121c606 = '20px';
const $fb842dc45fcee8c3$export$c8b5dc30e9f2b86e = '4px';
const $fb842dc45fcee8c3$export$82ea42e772d49e5b = (0, $lcnyw.gridSize)();
const $fb842dc45fcee8c3$export$eeeea0ff98e06fff = $fb842dc45fcee8c3$export$82ea42e772d49e5b * 2;
const $fb842dc45fcee8c3$export$254015fe817dcb9e = '--ds--code--line-number-bg-color';
const $fb842dc45fcee8c3$export$1758fda69688282e = '--ds--code--bg-color';
const $fb842dc45fcee8c3$export$2cd00c745c539a1 = `data-ds--code--code-block`;

});

parcelRegister("bQ0Ef", function(module, exports) {

$parcel$export(module.exports, "getBaseTheme", () => $531c36e6ab7cba4e$export$4464aa303b3e4fda);
$parcel$export(module.exports, "getColorPalette", () => $531c36e6ab7cba4e$export$fe2a6478976e8b17);

var $5iWql = parcelRequire("5iWql");


var $lcnyw = parcelRequire("lcnyw");
// Hardcoded values have been used due to the current color palette not having any
// accessible color options for Teal and Yellow and +20A
const $531c36e6ab7cba4e$var$T800 = '#067384';
const $531c36e6ab7cba4e$var$Y1100 = '#7A5D1A';
const $531c36e6ab7cba4e$export$4464aa303b3e4fda = ()=>({
        fontFamily: (0, $lcnyw.codeFontFamily)(),
        fontFamilyItalic: `SFMono-MediumItalic, ${(0, $lcnyw.codeFontFamily)()}`,
        backgroundColor: `var(--ds-background-neutral, ${$73a5c9d720aa66e1$export$9fdfb749e33cdf97})`,
        textColor: `var(--ds-text, ${$73a5c9d720aa66e1$export$7d61b15e0da132af})`,
        lineNumberColor: `var(--ds-text-subtlest, ${$73a5c9d720aa66e1$export$eece5f492e429f08})`,
        lineNumberBgColor: `var(--ds-background-neutral, ${$73a5c9d720aa66e1$export$3e51e8f1440314ba})`
    });
const $531c36e6ab7cba4e$export$7136e5d021a38178 = $531c36e6ab7cba4e$export$4464aa303b3e4fda();
const $531c36e6ab7cba4e$export$fe2a6478976e8b17 = (0, $5iWql.default)(()=>{
    return {
        highlightedLineBgColor: `var(--ds-background-neutral, ${$73a5c9d720aa66e1$export$3e51e8f1440314ba})`,
        highlightedLineBorderColor: `var(--ds-border-focused, ${$73a5c9d720aa66e1$export$215b7063051591f1})`,
        substringColor: `var(--ds-text-subtlest, ${$73a5c9d720aa66e1$export$eece5f492e429f08})`,
        keywordColor: `var(--ds-text-accent-blue, ${$73a5c9d720aa66e1$export$b3de0ae08da2ce64})`,
        attributeColor: `var(--ds-text-accent-teal, ${$531c36e6ab7cba4e$var$T800})`,
        selectorTagColor: `var(--ds-text-accent-blue, ${$73a5c9d720aa66e1$export$b3de0ae08da2ce64})`,
        docTagColor: `var(--ds-text-accent-yellow, ${$531c36e6ab7cba4e$var$Y1100})`,
        nameColor: `var(--ds-text-accent-blue, ${$73a5c9d720aa66e1$export$b3de0ae08da2ce64})`,
        builtInColor: `var(--ds-text-accent-blue, ${$73a5c9d720aa66e1$export$b3de0ae08da2ce64})`,
        literalColor: `var(--ds-text-accent-blue, ${$73a5c9d720aa66e1$export$b3de0ae08da2ce64})`,
        bulletColor: `var(--ds-text-accent-blue, ${$73a5c9d720aa66e1$export$b3de0ae08da2ce64})`,
        codeColor: `var(--ds-text-accent-blue, ${$73a5c9d720aa66e1$export$b3de0ae08da2ce64})`,
        regexpColor: `var(--ds-text-accent-teal, ${$531c36e6ab7cba4e$var$T800})`,
        symbolColor: `var(--ds-text-accent-teal, ${$531c36e6ab7cba4e$var$T800})`,
        variableColor: `var(--ds-text-accent-teal, ${$531c36e6ab7cba4e$var$T800})`,
        templateVariableColor: `var(--ds-text-accent-teal, ${$531c36e6ab7cba4e$var$T800})`,
        linkColor: `var(--ds-text-accent-purple, ${$73a5c9d720aa66e1$export$b48405b95304b5a1})`,
        selectorAttributeColor: `var(--ds-text-accent-teal, ${$531c36e6ab7cba4e$var$T800})`,
        selectorPseudoColor: `var(--ds-text-accent-teal, ${$531c36e6ab7cba4e$var$T800})`,
        typeColor: `var(--ds-text-accent-teal, ${$531c36e6ab7cba4e$var$T800})`,
        stringColor: `var(--ds-text-accent-green, ${$73a5c9d720aa66e1$export$6fa04827ac68a4fb})`,
        selectorIdColor: `var(--ds-text-accent-teal, ${$531c36e6ab7cba4e$var$T800})`,
        selectorClassColor: `var(--ds-text-accent-teal, ${$531c36e6ab7cba4e$var$T800})`,
        quoteColor: `var(--ds-text-accent-teal, ${$531c36e6ab7cba4e$var$T800})`,
        templateTagColor: `var(--ds-text-accent-teal, ${$531c36e6ab7cba4e$var$T800})`,
        titleColor: `var(--ds-text-accent-purple, ${$73a5c9d720aa66e1$export$b48405b95304b5a1})`,
        sectionColor: `var(--ds-text-accent-purple, ${$73a5c9d720aa66e1$export$b48405b95304b5a1})`,
        commentColor: `var(--ds-text-subtlest, ${$73a5c9d720aa66e1$export$eece5f492e429f08})`,
        metaKeywordColor: `var(--ds-text-accent-green, ${$73a5c9d720aa66e1$export$6fa04827ac68a4fb})`,
        metaColor: `var(--ds-text-subtlest, ${$73a5c9d720aa66e1$export$eece5f492e429f08})`,
        functionColor: `var(--ds-text, ${$73a5c9d720aa66e1$export$7d61b15e0da132af})`,
        numberColor: `var(--ds-text-accent-blue, ${$73a5c9d720aa66e1$export$b3de0ae08da2ce64})`,
        prologColor: `var(--ds-text-accent-blue, ${$73a5c9d720aa66e1$export$b3de0ae08da2ce64})`,
        cdataColor: `var(--ds-text-subtlest, ${$73a5c9d720aa66e1$export$eece5f492e429f08})`,
        punctuationColor: `var(--ds-text, ${$73a5c9d720aa66e1$export$7d61b15e0da132af})`,
        propertyColor: `var(--ds-text-accent-purple, ${$73a5c9d720aa66e1$export$b48405b95304b5a1})`,
        constantColor: `var(--ds-text-accent-teal, ${$531c36e6ab7cba4e$var$T800})`,
        booleanColor: `var(--ds-text-accent-blue, ${$73a5c9d720aa66e1$export$b3de0ae08da2ce64})`,
        charColor: `var(--ds-text, ${$73a5c9d720aa66e1$export$7d61b15e0da132af})`,
        insertedColor: `var(--ds-text-accent-green, ${$73a5c9d720aa66e1$export$6fa04827ac68a4fb})`,
        deletedColor: `var(--ds-text-accent-red, ${$73a5c9d720aa66e1$export$2837b5a1a71d5c02})`,
        operatorColor: `var(--ds-text, ${$73a5c9d720aa66e1$export$7d61b15e0da132af})`,
        atruleColor: `var(--ds-text-accent-green, ${$73a5c9d720aa66e1$export$6fa04827ac68a4fb})`,
        importantColor: `var(--ds-text-accent-yellow, ${$531c36e6ab7cba4e$var$Y1100})`
    };
});
const $531c36e6ab7cba4e$var$getTheme = ()=>({
        ...$531c36e6ab7cba4e$export$4464aa303b3e4fda(),
        ...$531c36e6ab7cba4e$export$fe2a6478976e8b17()
    });
var $531c36e6ab7cba4e$export$2e2bcd8739ae039 = $531c36e6ab7cba4e$var$getTheme;

});
var $73a5c9d720aa66e1$exports = {};

$parcel$export($73a5c9d720aa66e1$exports, "R50", () => $73a5c9d720aa66e1$export$4b84fd0e2c617bd);
$parcel$export($73a5c9d720aa66e1$exports, "R75", () => $73a5c9d720aa66e1$export$b34b069eff244586);
$parcel$export($73a5c9d720aa66e1$exports, "R100", () => $73a5c9d720aa66e1$export$be802dd0d8b57f35);
$parcel$export($73a5c9d720aa66e1$exports, "R200", () => $73a5c9d720aa66e1$export$60847d42f9da92a6);
$parcel$export($73a5c9d720aa66e1$exports, "R300", () => $73a5c9d720aa66e1$export$4a7404f376229999);
$parcel$export($73a5c9d720aa66e1$exports, "R400", () => $73a5c9d720aa66e1$export$2010d0fb4295b346);
$parcel$export($73a5c9d720aa66e1$exports, "R500", () => $73a5c9d720aa66e1$export$2837b5a1a71d5c02);
$parcel$export($73a5c9d720aa66e1$exports, "Y50", () => $73a5c9d720aa66e1$export$8d9596b529bbb9cf);
$parcel$export($73a5c9d720aa66e1$exports, "Y75", () => $73a5c9d720aa66e1$export$41060a744ab0b7ae);
$parcel$export($73a5c9d720aa66e1$exports, "Y100", () => $73a5c9d720aa66e1$export$1cc05bbbf340e559);
$parcel$export($73a5c9d720aa66e1$exports, "Y200", () => $73a5c9d720aa66e1$export$5aae31392d72caaa);
$parcel$export($73a5c9d720aa66e1$exports, "Y300", () => $73a5c9d720aa66e1$export$c6930421db9fa514);
$parcel$export($73a5c9d720aa66e1$exports, "Y400", () => $73a5c9d720aa66e1$export$59619663aa6500fb);
$parcel$export($73a5c9d720aa66e1$exports, "Y500", () => $73a5c9d720aa66e1$export$874739ea9e379ab6);
$parcel$export($73a5c9d720aa66e1$exports, "G50", () => $73a5c9d720aa66e1$export$8a6341c32b6a3ee6);
$parcel$export($73a5c9d720aa66e1$exports, "G75", () => $73a5c9d720aa66e1$export$69a3bf21b9686c2b);
$parcel$export($73a5c9d720aa66e1$exports, "G100", () => $73a5c9d720aa66e1$export$afbce1382ec95f73);
$parcel$export($73a5c9d720aa66e1$exports, "G200", () => $73a5c9d720aa66e1$export$747d86715d4175de);
$parcel$export($73a5c9d720aa66e1$exports, "G300", () => $73a5c9d720aa66e1$export$940e1f69e873f202);
$parcel$export($73a5c9d720aa66e1$exports, "G400", () => $73a5c9d720aa66e1$export$a49394138f7b8e85);
$parcel$export($73a5c9d720aa66e1$exports, "G500", () => $73a5c9d720aa66e1$export$6fa04827ac68a4fb);
$parcel$export($73a5c9d720aa66e1$exports, "B50", () => $73a5c9d720aa66e1$export$226de0355ed012f8);
$parcel$export($73a5c9d720aa66e1$exports, "B75", () => $73a5c9d720aa66e1$export$8c13c2ee36917869);
$parcel$export($73a5c9d720aa66e1$exports, "B100", () => $73a5c9d720aa66e1$export$ecfc1dff386a3e7a);
$parcel$export($73a5c9d720aa66e1$exports, "B200", () => $73a5c9d720aa66e1$export$215b7063051591f1);
$parcel$export($73a5c9d720aa66e1$exports, "B300", () => $73a5c9d720aa66e1$export$e62e8919cca44969);
$parcel$export($73a5c9d720aa66e1$exports, "B400", () => $73a5c9d720aa66e1$export$b3de0ae08da2ce64);
$parcel$export($73a5c9d720aa66e1$exports, "B500", () => $73a5c9d720aa66e1$export$a6ee3d71bc067634);
$parcel$export($73a5c9d720aa66e1$exports, "P50", () => $73a5c9d720aa66e1$export$363e4475840015bb);
$parcel$export($73a5c9d720aa66e1$exports, "P75", () => $73a5c9d720aa66e1$export$4b0a4417ed59760f);
$parcel$export($73a5c9d720aa66e1$exports, "P100", () => $73a5c9d720aa66e1$export$6011520a64d9a187);
$parcel$export($73a5c9d720aa66e1$exports, "P200", () => $73a5c9d720aa66e1$export$a7175d4e9206bc80);
$parcel$export($73a5c9d720aa66e1$exports, "P300", () => $73a5c9d720aa66e1$export$b48405b95304b5a1);
$parcel$export($73a5c9d720aa66e1$exports, "P400", () => $73a5c9d720aa66e1$export$c71e4279dd54a18d);
$parcel$export($73a5c9d720aa66e1$exports, "P500", () => $73a5c9d720aa66e1$export$147899de772240ec);
$parcel$export($73a5c9d720aa66e1$exports, "T50", () => $73a5c9d720aa66e1$export$2cf711fe14c66f06);
$parcel$export($73a5c9d720aa66e1$exports, "T75", () => $73a5c9d720aa66e1$export$7a8f4d33f6f9772c);
$parcel$export($73a5c9d720aa66e1$exports, "T100", () => $73a5c9d720aa66e1$export$776c9c497ef08533);
$parcel$export($73a5c9d720aa66e1$exports, "T200", () => $73a5c9d720aa66e1$export$69cb3ca10c1e330e);
$parcel$export($73a5c9d720aa66e1$exports, "T300", () => $73a5c9d720aa66e1$export$9dc1ef0f3f48059b);
$parcel$export($73a5c9d720aa66e1$exports, "T400", () => $73a5c9d720aa66e1$export$7c835c78b6fcdef8);
$parcel$export($73a5c9d720aa66e1$exports, "T500", () => $73a5c9d720aa66e1$export$6036577f95c3877e);
$parcel$export($73a5c9d720aa66e1$exports, "N0", () => $73a5c9d720aa66e1$export$29a4f05edc054374);
$parcel$export($73a5c9d720aa66e1$exports, "N10", () => $73a5c9d720aa66e1$export$e655ef011c4aa1a2);
$parcel$export($73a5c9d720aa66e1$exports, "N20", () => $73a5c9d720aa66e1$export$9fdfb749e33cdf97);
$parcel$export($73a5c9d720aa66e1$exports, "N30", () => $73a5c9d720aa66e1$export$3e51e8f1440314ba);
$parcel$export($73a5c9d720aa66e1$exports, "N40", () => $73a5c9d720aa66e1$export$1ce2d1575d444ceb);
$parcel$export($73a5c9d720aa66e1$exports, "N50", () => $73a5c9d720aa66e1$export$8754fc7e6d8b3000);
$parcel$export($73a5c9d720aa66e1$exports, "N60", () => $73a5c9d720aa66e1$export$c2e91cbeada39b8b);
$parcel$export($73a5c9d720aa66e1$exports, "N70", () => $73a5c9d720aa66e1$export$5f71e19f3a7ad9de);
$parcel$export($73a5c9d720aa66e1$exports, "N80", () => $73a5c9d720aa66e1$export$eaa8c8a70ac22806);
$parcel$export($73a5c9d720aa66e1$exports, "N90", () => $73a5c9d720aa66e1$export$7c87d337fb91a97d);
$parcel$export($73a5c9d720aa66e1$exports, "N100", () => $73a5c9d720aa66e1$export$d6447c357493214f);
$parcel$export($73a5c9d720aa66e1$exports, "N200", () => $73a5c9d720aa66e1$export$f563ee71e9ee74cd);
$parcel$export($73a5c9d720aa66e1$exports, "N300", () => $73a5c9d720aa66e1$export$e2ef2124cf4024b1);
$parcel$export($73a5c9d720aa66e1$exports, "N400", () => $73a5c9d720aa66e1$export$eece5f492e429f08);
$parcel$export($73a5c9d720aa66e1$exports, "N500", () => $73a5c9d720aa66e1$export$c39c0fe0f26207ae);
$parcel$export($73a5c9d720aa66e1$exports, "N600", () => $73a5c9d720aa66e1$export$7090862dc3038a9f);
$parcel$export($73a5c9d720aa66e1$exports, "N700", () => $73a5c9d720aa66e1$export$ad0bacf983b7ddaa);
$parcel$export($73a5c9d720aa66e1$exports, "N800", () => $73a5c9d720aa66e1$export$7d61b15e0da132af);
$parcel$export($73a5c9d720aa66e1$exports, "N900", () => $73a5c9d720aa66e1$export$fbda843f0a27fe96);
$parcel$export($73a5c9d720aa66e1$exports, "N10A", () => $73a5c9d720aa66e1$export$791e57b27ca738ef);
$parcel$export($73a5c9d720aa66e1$exports, "N20A", () => $73a5c9d720aa66e1$export$8d43898f60b96a82);
$parcel$export($73a5c9d720aa66e1$exports, "N30A", () => $73a5c9d720aa66e1$export$920c0d5c49070351);
$parcel$export($73a5c9d720aa66e1$exports, "N40A", () => $73a5c9d720aa66e1$export$46987b49aab6d1a8);
$parcel$export($73a5c9d720aa66e1$exports, "N50A", () => $73a5c9d720aa66e1$export$7d3359664e8bb0e5);
$parcel$export($73a5c9d720aa66e1$exports, "N60A", () => $73a5c9d720aa66e1$export$d2d3bedfb276cac0);
$parcel$export($73a5c9d720aa66e1$exports, "N70A", () => $73a5c9d720aa66e1$export$6e5e7499ff054f6d);
$parcel$export($73a5c9d720aa66e1$exports, "N80A", () => $73a5c9d720aa66e1$export$59264b346c877fa7);
$parcel$export($73a5c9d720aa66e1$exports, "N90A", () => $73a5c9d720aa66e1$export$d092757d7c64925c);
$parcel$export($73a5c9d720aa66e1$exports, "N100A", () => $73a5c9d720aa66e1$export$486ab785e4bac3c6);
$parcel$export($73a5c9d720aa66e1$exports, "N200A", () => $73a5c9d720aa66e1$export$fba592bbc6419fea);
$parcel$export($73a5c9d720aa66e1$exports, "N300A", () => $73a5c9d720aa66e1$export$13609db0e6812ab8);
$parcel$export($73a5c9d720aa66e1$exports, "N400A", () => $73a5c9d720aa66e1$export$fbae4efaa892d883);
$parcel$export($73a5c9d720aa66e1$exports, "N500A", () => $73a5c9d720aa66e1$export$f13946d26f440ce6);
$parcel$export($73a5c9d720aa66e1$exports, "N600A", () => $73a5c9d720aa66e1$export$19f58225ac52a306);
$parcel$export($73a5c9d720aa66e1$exports, "N700A", () => $73a5c9d720aa66e1$export$6384f09da70e7b62);
$parcel$export($73a5c9d720aa66e1$exports, "N800A", () => $73a5c9d720aa66e1$export$d0dccc730683edc2);
$parcel$export($73a5c9d720aa66e1$exports, "DN900", () => $73a5c9d720aa66e1$export$2f6319cf7d736c2a);
$parcel$export($73a5c9d720aa66e1$exports, "DN800", () => $73a5c9d720aa66e1$export$95126bc8884d6634);
$parcel$export($73a5c9d720aa66e1$exports, "DN700", () => $73a5c9d720aa66e1$export$8338d8c35d44ff1);
$parcel$export($73a5c9d720aa66e1$exports, "DN600", () => $73a5c9d720aa66e1$export$5368d76ae4fbbda7);
$parcel$export($73a5c9d720aa66e1$exports, "DN500", () => $73a5c9d720aa66e1$export$9f0a771d16ec8d36);
$parcel$export($73a5c9d720aa66e1$exports, "DN400", () => $73a5c9d720aa66e1$export$abcf8c38338b4aa5);
$parcel$export($73a5c9d720aa66e1$exports, "DN300", () => $73a5c9d720aa66e1$export$97e81faa16a182c7);
$parcel$export($73a5c9d720aa66e1$exports, "DN200", () => $73a5c9d720aa66e1$export$bfe21c59123ecf33);
$parcel$export($73a5c9d720aa66e1$exports, "DN100", () => $73a5c9d720aa66e1$export$ee82aa2ea6a1558);
$parcel$export($73a5c9d720aa66e1$exports, "DN90", () => $73a5c9d720aa66e1$export$682927c6ed76be02);
$parcel$export($73a5c9d720aa66e1$exports, "DN80", () => $73a5c9d720aa66e1$export$91fd9994c5be9757);
$parcel$export($73a5c9d720aa66e1$exports, "DN70", () => $73a5c9d720aa66e1$export$d281fbfe3cff2df6);
$parcel$export($73a5c9d720aa66e1$exports, "DN60", () => $73a5c9d720aa66e1$export$3902c91d8b98a753);
$parcel$export($73a5c9d720aa66e1$exports, "DN50", () => $73a5c9d720aa66e1$export$8e8133c1ba5845b5);
$parcel$export($73a5c9d720aa66e1$exports, "DN40", () => $73a5c9d720aa66e1$export$33ff357f6620b39);
$parcel$export($73a5c9d720aa66e1$exports, "DN30", () => $73a5c9d720aa66e1$export$633847cf062b69e0);
$parcel$export($73a5c9d720aa66e1$exports, "DN20", () => $73a5c9d720aa66e1$export$9776a6e503bdbf76);
$parcel$export($73a5c9d720aa66e1$exports, "DN10", () => $73a5c9d720aa66e1$export$6c813d5160dff5db);
$parcel$export($73a5c9d720aa66e1$exports, "DN0", () => $73a5c9d720aa66e1$export$3d4f271a500072a);
$parcel$export($73a5c9d720aa66e1$exports, "DN800A", () => $73a5c9d720aa66e1$export$fe151285c22759ec);
$parcel$export($73a5c9d720aa66e1$exports, "DN700A", () => $73a5c9d720aa66e1$export$a101c6190d0da34);
$parcel$export($73a5c9d720aa66e1$exports, "DN600A", () => $73a5c9d720aa66e1$export$4b16f52932fda51);
$parcel$export($73a5c9d720aa66e1$exports, "DN500A", () => $73a5c9d720aa66e1$export$a74bcd7b9845b0d8);
$parcel$export($73a5c9d720aa66e1$exports, "DN400A", () => $73a5c9d720aa66e1$export$9209c179316d1751);
$parcel$export($73a5c9d720aa66e1$exports, "DN300A", () => $73a5c9d720aa66e1$export$88f55133f636c8dd);
$parcel$export($73a5c9d720aa66e1$exports, "DN200A", () => $73a5c9d720aa66e1$export$51126f85d1009512);
$parcel$export($73a5c9d720aa66e1$exports, "DN100A", () => $73a5c9d720aa66e1$export$a069b547bd23af78);
$parcel$export($73a5c9d720aa66e1$exports, "DN90A", () => $73a5c9d720aa66e1$export$40cce05af3b2600a);
$parcel$export($73a5c9d720aa66e1$exports, "DN80A", () => $73a5c9d720aa66e1$export$b78942185925a0d);
$parcel$export($73a5c9d720aa66e1$exports, "DN70A", () => $73a5c9d720aa66e1$export$e058fb44b8eaafca);
$parcel$export($73a5c9d720aa66e1$exports, "DN60A", () => $73a5c9d720aa66e1$export$92b0b8de26920c18);
$parcel$export($73a5c9d720aa66e1$exports, "DN50A", () => $73a5c9d720aa66e1$export$67564f7459d3fc9e);
$parcel$export($73a5c9d720aa66e1$exports, "DN40A", () => $73a5c9d720aa66e1$export$77868e1ca884ffa3);
$parcel$export($73a5c9d720aa66e1$exports, "DN30A", () => $73a5c9d720aa66e1$export$2afd71d7d3ea2cd5);
$parcel$export($73a5c9d720aa66e1$exports, "DN20A", () => $73a5c9d720aa66e1$export$f2a0acaab9972c70);
$parcel$export($73a5c9d720aa66e1$exports, "DN10A", () => $73a5c9d720aa66e1$export$9ab70e67d6475361);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
const $73a5c9d720aa66e1$export$4b84fd0e2c617bd = '#FFEBE6';
const $73a5c9d720aa66e1$export$b34b069eff244586 = '#FFBDAD';
const $73a5c9d720aa66e1$export$be802dd0d8b57f35 = '#FF8F73';
const $73a5c9d720aa66e1$export$60847d42f9da92a6 = '#FF7452';
const $73a5c9d720aa66e1$export$4a7404f376229999 = '#FF5630';
const $73a5c9d720aa66e1$export$2010d0fb4295b346 = '#DE350B';
const $73a5c9d720aa66e1$export$2837b5a1a71d5c02 = '#BF2600';
const $73a5c9d720aa66e1$export$8d9596b529bbb9cf = '#FFFAE6';
const $73a5c9d720aa66e1$export$41060a744ab0b7ae = '#FFF0B3';
const $73a5c9d720aa66e1$export$1cc05bbbf340e559 = '#FFE380';
const $73a5c9d720aa66e1$export$5aae31392d72caaa = '#FFC400';
const $73a5c9d720aa66e1$export$c6930421db9fa514 = '#FFAB00';
const $73a5c9d720aa66e1$export$59619663aa6500fb = '#FF991F';
const $73a5c9d720aa66e1$export$874739ea9e379ab6 = '#FF8B00';
const $73a5c9d720aa66e1$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $73a5c9d720aa66e1$export$69a3bf21b9686c2b = '#ABF5D1';
const $73a5c9d720aa66e1$export$afbce1382ec95f73 = '#79F2C0';
const $73a5c9d720aa66e1$export$747d86715d4175de = '#57D9A3';
const $73a5c9d720aa66e1$export$940e1f69e873f202 = '#36B37E';
const $73a5c9d720aa66e1$export$a49394138f7b8e85 = '#00875A';
const $73a5c9d720aa66e1$export$6fa04827ac68a4fb = '#006644';
const $73a5c9d720aa66e1$export$226de0355ed012f8 = '#DEEBFF';
const $73a5c9d720aa66e1$export$8c13c2ee36917869 = '#B3D4FF';
const $73a5c9d720aa66e1$export$ecfc1dff386a3e7a = '#4C9AFF';
const $73a5c9d720aa66e1$export$215b7063051591f1 = '#2684FF';
const $73a5c9d720aa66e1$export$e62e8919cca44969 = '#0065FF';
const $73a5c9d720aa66e1$export$b3de0ae08da2ce64 = '#0052CC';
const $73a5c9d720aa66e1$export$a6ee3d71bc067634 = '#0747A6';
const $73a5c9d720aa66e1$export$363e4475840015bb = '#EAE6FF';
const $73a5c9d720aa66e1$export$4b0a4417ed59760f = '#C0B6F2';
const $73a5c9d720aa66e1$export$6011520a64d9a187 = '#998DD9';
const $73a5c9d720aa66e1$export$a7175d4e9206bc80 = '#8777D9';
const $73a5c9d720aa66e1$export$b48405b95304b5a1 = '#6554C0';
const $73a5c9d720aa66e1$export$c71e4279dd54a18d = '#5243AA';
const $73a5c9d720aa66e1$export$147899de772240ec = '#403294';
const $73a5c9d720aa66e1$export$2cf711fe14c66f06 = '#E6FCFF';
const $73a5c9d720aa66e1$export$7a8f4d33f6f9772c = '#B3F5FF';
const $73a5c9d720aa66e1$export$776c9c497ef08533 = '#79E2F2';
const $73a5c9d720aa66e1$export$69cb3ca10c1e330e = '#00C7E6';
const $73a5c9d720aa66e1$export$9dc1ef0f3f48059b = '#00B8D9';
const $73a5c9d720aa66e1$export$7c835c78b6fcdef8 = '#00A3BF';
const $73a5c9d720aa66e1$export$6036577f95c3877e = '#008DA6';
const $73a5c9d720aa66e1$export$29a4f05edc054374 = '#FFFFFF';
const $73a5c9d720aa66e1$export$e655ef011c4aa1a2 = '#FAFBFC';
const $73a5c9d720aa66e1$export$9fdfb749e33cdf97 = '#F4F5F7';
const $73a5c9d720aa66e1$export$3e51e8f1440314ba = '#EBECF0';
const $73a5c9d720aa66e1$export$1ce2d1575d444ceb = '#DFE1E6';
const $73a5c9d720aa66e1$export$8754fc7e6d8b3000 = '#C1C7D0';
const $73a5c9d720aa66e1$export$c2e91cbeada39b8b = '#B3BAC5';
const $73a5c9d720aa66e1$export$5f71e19f3a7ad9de = '#A5ADBA';
const $73a5c9d720aa66e1$export$eaa8c8a70ac22806 = '#97A0AF';
const $73a5c9d720aa66e1$export$7c87d337fb91a97d = '#8993A4';
const $73a5c9d720aa66e1$export$d6447c357493214f = '#7A869A';
const $73a5c9d720aa66e1$export$f563ee71e9ee74cd = '#6B778C';
const $73a5c9d720aa66e1$export$e2ef2124cf4024b1 = '#5E6C84';
const $73a5c9d720aa66e1$export$eece5f492e429f08 = '#505F79';
const $73a5c9d720aa66e1$export$c39c0fe0f26207ae = '#42526E';
const $73a5c9d720aa66e1$export$7090862dc3038a9f = '#344563';
const $73a5c9d720aa66e1$export$ad0bacf983b7ddaa = '#253858';
const $73a5c9d720aa66e1$export$7d61b15e0da132af = '#172B4D';
const $73a5c9d720aa66e1$export$fbda843f0a27fe96 = '#091E42';
const $73a5c9d720aa66e1$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $73a5c9d720aa66e1$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $73a5c9d720aa66e1$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $73a5c9d720aa66e1$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $73a5c9d720aa66e1$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $73a5c9d720aa66e1$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $73a5c9d720aa66e1$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $73a5c9d720aa66e1$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $73a5c9d720aa66e1$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $73a5c9d720aa66e1$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $73a5c9d720aa66e1$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $73a5c9d720aa66e1$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $73a5c9d720aa66e1$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $73a5c9d720aa66e1$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $73a5c9d720aa66e1$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $73a5c9d720aa66e1$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $73a5c9d720aa66e1$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $73a5c9d720aa66e1$export$2f6319cf7d736c2a = '#E6EDFA';
const $73a5c9d720aa66e1$export$95126bc8884d6634 = '#DCE5F5';
const $73a5c9d720aa66e1$export$8338d8c35d44ff1 = '#CED9EB';
const $73a5c9d720aa66e1$export$5368d76ae4fbbda7 = '#B8C7E0';
const $73a5c9d720aa66e1$export$9f0a771d16ec8d36 = '#ABBBD6';
const $73a5c9d720aa66e1$export$abcf8c38338b4aa5 = '#9FB0CC';
const $73a5c9d720aa66e1$export$97e81faa16a182c7 = '#8C9CB8';
const $73a5c9d720aa66e1$export$bfe21c59123ecf33 = '#7988A3';
const $73a5c9d720aa66e1$export$ee82aa2ea6a1558 = '#67758F';
const $73a5c9d720aa66e1$export$682927c6ed76be02 = '#56637A';
const $73a5c9d720aa66e1$export$91fd9994c5be9757 = '#455166';
const $73a5c9d720aa66e1$export$d281fbfe3cff2df6 = '#3B475C';
const $73a5c9d720aa66e1$export$3902c91d8b98a753 = '#313D52';
const $73a5c9d720aa66e1$export$8e8133c1ba5845b5 = '#283447';
const $73a5c9d720aa66e1$export$33ff357f6620b39 = '#202B3D';
const $73a5c9d720aa66e1$export$633847cf062b69e0 = '#1B2638';
const $73a5c9d720aa66e1$export$9776a6e503bdbf76 = '#121A29';
const $73a5c9d720aa66e1$export$6c813d5160dff5db = '#0E1624';
const $73a5c9d720aa66e1$export$3d4f271a500072a = '#0D1424';
const $73a5c9d720aa66e1$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $73a5c9d720aa66e1$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $73a5c9d720aa66e1$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $73a5c9d720aa66e1$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $73a5c9d720aa66e1$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $73a5c9d720aa66e1$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $73a5c9d720aa66e1$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $73a5c9d720aa66e1$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $73a5c9d720aa66e1$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $73a5c9d720aa66e1$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $73a5c9d720aa66e1$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $73a5c9d720aa66e1$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $73a5c9d720aa66e1$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $73a5c9d720aa66e1$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $73a5c9d720aa66e1$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $73a5c9d720aa66e1$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $73a5c9d720aa66e1$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';



parcelRegister("4BdAI", function(module, exports) {

$parcel$export(module.exports, "normalizeLanguage", () => $b827b836b199e27f$export$f38728011c178796);

var $5iWql = parcelRequire("5iWql");

var $1le93 = parcelRequire("1le93");
const $b827b836b199e27f$export$f38728011c178796 = (0, $5iWql.default)((language)=>{
    if (!language) return '';
    const match = (0, $1le93.SUPPORTED_LANGUAGES).find((val)=>{
        return val.name === language || val.alias.includes(language);
    });
    // Fallback to plain monospaced text if language passed but not supported
    return match ? match.value : 'text';
});

});
parcelRegister("1le93", function(module, exports) {

$parcel$export(module.exports, "SUPPORTED_LANGUAGES", () => $f71e16503ef6aaeb$export$7c77c3a9bb93870d);
// The full list of languages that can potentially be supported is found in
// https://prismjs.com/#supported-languages

const $f71e16503ef6aaeb$export$7c77c3a9bb93870d = [
    {
        name: 'PHP',
        alias: [
            'php',
            'php3',
            'php4',
            'php5'
        ],
        value: 'php'
    },
    {
        name: 'Java',
        alias: [
            'java'
        ],
        value: 'java'
    },
    {
        name: 'CSharp',
        alias: [
            'csharp',
            'c#'
        ],
        value: 'cs'
    },
    {
        name: 'Python',
        alias: [
            'python',
            'py'
        ],
        value: 'python'
    },
    {
        name: 'JavaScript',
        alias: [
            'javascript',
            'js'
        ],
        value: 'javascript'
    },
    {
        name: 'Html',
        alias: [
            'html'
        ],
        value: 'xml'
    },
    {
        name: 'C++',
        alias: [
            'c++',
            'cpp',
            'clike'
        ],
        value: 'cpp'
    },
    {
        name: 'Ruby',
        alias: [
            'ruby',
            'rb',
            'duby'
        ],
        value: 'ruby'
    },
    {
        name: 'Objective-C',
        alias: [
            'objective-c',
            'objectivec',
            'obj-c',
            'objc'
        ],
        value: 'objectivec'
    },
    {
        name: 'C',
        alias: [
            'c'
        ],
        value: 'cpp'
    },
    {
        name: 'Swift',
        alias: [
            'swift'
        ],
        value: 'swift'
    },
    {
        name: 'TeX',
        alias: [
            'tex',
            'latex'
        ],
        value: 'tex'
    },
    {
        name: 'Shell',
        alias: [
            'shell',
            'bash',
            'sh',
            'ksh',
            'zsh'
        ],
        value: 'shell'
    },
    {
        name: 'Scala',
        alias: [
            'scala'
        ],
        value: 'scala'
    },
    {
        name: 'Go',
        alias: [
            'go'
        ],
        value: 'go'
    },
    {
        name: 'ActionScript',
        alias: [
            'actionscript',
            'actionscript3',
            'as'
        ],
        value: 'actionscript'
    },
    {
        name: 'ColdFusion',
        alias: [
            'coldfusion'
        ],
        value: 'xml'
    },
    {
        name: 'JavaFX',
        alias: [
            'javafx',
            'jfx'
        ],
        value: 'java'
    },
    {
        name: 'VbNet',
        alias: [
            'vbnet',
            'vb.net',
            'vfp',
            'clipper',
            'xbase'
        ],
        value: 'vbnet'
    },
    {
        name: 'JSON',
        alias: [
            'json'
        ],
        value: 'json'
    },
    {
        name: 'MATLAB',
        alias: [
            'matlab'
        ],
        value: 'matlab'
    },
    {
        name: 'Groovy',
        alias: [
            'groovy'
        ],
        value: 'groovy'
    },
    {
        name: 'SQL',
        alias: [
            'sql',
            'postgresql',
            'postgres',
            'plpgsql',
            'psql',
            'postgresql-console',
            'postgres-console',
            'tsql',
            't-sql',
            'mysql',
            'sqlite'
        ],
        value: 'sql'
    },
    {
        name: 'R',
        alias: [
            'r'
        ],
        value: 'r'
    },
    {
        name: 'Perl',
        alias: [
            'perl',
            'pl'
        ],
        value: 'perl'
    },
    {
        name: 'Lua',
        alias: [
            'lua'
        ],
        value: 'lua'
    },
    {
        name: 'Pascal',
        alias: [
            'pas',
            'pascal',
            'objectpascal',
            'delphi'
        ],
        value: 'pascal'
    },
    {
        name: 'XML',
        alias: [
            'xml'
        ],
        value: 'xml'
    },
    {
        name: 'TypeScript',
        alias: [
            'typescript',
            'ts'
        ],
        value: 'typescript'
    },
    {
        name: 'CoffeeScript',
        alias: [
            'coffeescript',
            'coffee-script',
            'coffee'
        ],
        value: 'coffeescript'
    },
    {
        name: 'Haskell',
        alias: [
            'haskell',
            'hs'
        ],
        value: 'haskell'
    },
    {
        name: 'Puppet',
        alias: [
            'puppet'
        ],
        value: 'puppet'
    },
    {
        name: 'Arduino',
        alias: [
            'arduino'
        ],
        value: 'arduino'
    },
    {
        name: 'Fortran',
        alias: [
            'fortran'
        ],
        value: 'fortran'
    },
    {
        name: 'Erlang',
        alias: [
            'erlang',
            'erl'
        ],
        value: 'erlang'
    },
    {
        name: 'PowerShell',
        alias: [
            'powershell',
            'posh',
            'ps1',
            'psm1'
        ],
        value: 'powershell'
    },
    {
        name: 'Haxe',
        alias: [
            'haxe',
            'hx',
            'hxsl'
        ],
        value: 'haxe'
    },
    {
        name: 'Elixir',
        alias: [
            'elixir',
            'ex',
            'exs'
        ],
        value: 'elixir'
    },
    {
        name: 'Verilog',
        alias: [
            'verilog',
            'v'
        ],
        value: 'verilog'
    },
    {
        name: 'Rust',
        alias: [
            'rust'
        ],
        value: 'rust'
    },
    {
        name: 'VHDL',
        alias: [
            'vhdl'
        ],
        value: 'vhdl'
    },
    {
        name: 'Sass',
        alias: [
            'sass'
        ],
        value: 'less'
    },
    {
        name: 'OCaml',
        alias: [
            'ocaml'
        ],
        value: 'ocaml'
    },
    {
        name: 'Dart',
        alias: [
            'dart'
        ],
        value: 'dart'
    },
    {
        name: 'CSS',
        alias: [
            'css'
        ],
        value: 'css'
    },
    {
        name: 'reStructuredText',
        alias: [
            'restructuredtext',
            'rst',
            'rest'
        ],
        value: 'rest'
    },
    {
        name: 'Kotlin',
        alias: [
            'kotlin'
        ],
        value: 'kotlin'
    },
    {
        name: 'D',
        alias: [
            'd'
        ],
        value: 'd'
    },
    {
        name: 'Octave',
        alias: [
            'octave'
        ],
        value: 'matlab'
    },
    {
        name: 'QML',
        alias: [
            'qbs',
            'qml'
        ],
        value: 'qml'
    },
    {
        name: 'Prolog',
        alias: [
            'prolog'
        ],
        value: 'prolog'
    },
    {
        name: 'FoxPro',
        alias: [
            'foxpro',
            'purebasic'
        ],
        value: 'purebasic'
    },
    {
        name: 'Scheme',
        alias: [
            'scheme',
            'scm'
        ],
        value: 'scheme'
    },
    {
        name: 'CUDA',
        alias: [
            'cuda',
            'cu'
        ],
        value: 'cpp'
    },
    {
        name: 'Julia',
        alias: [
            'julia',
            'jl'
        ],
        value: 'julia'
    },
    {
        name: 'Racket',
        alias: [
            'racket',
            'rkt'
        ],
        value: 'lisp'
    },
    {
        name: 'Ada',
        alias: [
            'ada',
            'ada95',
            'ada2005'
        ],
        value: 'ada'
    },
    {
        name: 'Tcl',
        alias: [
            'tcl'
        ],
        value: 'tcl'
    },
    {
        name: 'Mathematica',
        alias: [
            'mathematica',
            'mma',
            'nb'
        ],
        value: 'mathematica'
    },
    {
        name: 'Autoit',
        alias: [
            'autoit'
        ],
        value: 'autoit'
    },
    {
        name: 'StandardML',
        alias: [
            'standardmL',
            'sml',
            'standardml'
        ],
        value: 'sml'
    },
    {
        name: 'Objective-J',
        alias: [
            'objective-j',
            'objectivej',
            'obj-j',
            'objj'
        ],
        value: 'objectivec'
    },
    {
        name: 'Smalltalk',
        alias: [
            'smalltalk',
            'squeak',
            'st'
        ],
        value: 'smalltalk'
    },
    {
        name: 'Vala',
        alias: [
            'vala',
            'vapi'
        ],
        value: 'vala'
    },
    {
        name: 'ABAP',
        alias: [
            'abap'
        ],
        value: 'sql'
    },
    {
        name: 'LiveScript',
        alias: [
            'livescript',
            'live-script'
        ],
        value: 'livescript'
    },
    {
        name: 'XQuery',
        alias: [
            'xquery',
            'xqy',
            'xq',
            'xql',
            'xqm'
        ],
        value: 'xquery'
    },
    {
        name: 'PlainText',
        alias: [
            'text',
            'plaintext'
        ],
        value: 'text'
    },
    {
        name: 'Yaml',
        alias: [
            'yaml',
            'yml'
        ],
        value: 'yaml'
    },
    {
        name: 'GraphQL',
        alias: [
            'graphql'
        ],
        value: 'graphql'
    },
    {
        name: 'AppleScript',
        alias: [
            'applescript'
        ],
        value: 'applescript'
    },
    {
        name: 'Clojure',
        alias: [
            'clojure'
        ],
        value: 'clojure'
    },
    {
        name: 'Diff',
        alias: [
            'diff'
        ],
        value: 'diff'
    },
    {
        name: 'VisualBasic',
        alias: [
            'visualbasic'
        ],
        value: 'visual-basic'
    },
    {
        name: 'JSX',
        alias: [
            'jsx'
        ],
        value: 'jsx'
    },
    {
        name: 'TSX',
        alias: [
            'tsx'
        ],
        value: 'tsx'
    },
    {
        name: 'SplunkSPL',
        alias: [
            'splunk-spl'
        ],
        value: 'splunk-spl'
    },
    {
        name: 'Dockerfile',
        alias: [
            'docker',
            'dockerfile'
        ],
        value: 'dockerfile'
    },
    {
        name: 'HCL',
        alias: [
            'hcl',
            'terraform'
        ],
        value: 'hcl'
    },
    {
        name: 'NGINX',
        alias: [
            'nginx'
        ],
        value: 'nginx'
    },
    {
        name: 'Protocol Buffers',
        alias: [
            'protobuf',
            'proto'
        ],
        value: 'protobuf'
    }
];

});


parcelRegister("dvVZk", function(module, exports) {

$parcel$export(module.exports, "default", () => $f80072a0bbd9c98f$export$2e2bcd8739ae039);
/**
 * Original library: https://github.com/react-syntax-highlighter/react-syntax-highlighter
 * All modifications by Atlassian
 */ /**
 * MIT License
 *
 * Copyright (c) 2019 Conor Hastings
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ /**
 * __Syntax Highlighter__
 *
 * A syntax highlighter based on top of [refractor](https://github.com/wooorm/refractor).
 * @atlaskit/code uses this under-the-hood, but it is not intended for public consumption.
 * You should be using @atlaskit/code directly.
 */ 
var $4tsFX = parcelRequire("4tsFX");
var $f80072a0bbd9c98f$export$2e2bcd8739ae039 = (0, $4tsFX.default);

});
parcelRegister("4tsFX", function(module, exports) {

$parcel$export(module.exports, "default", () => $b394a85de6e9d3f2$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5Fzqn = parcelRequire("5Fzqn");
// Uses the loader method of async bundling
// Instantiates highligher as a singleton, loading refractor only once per page (refractor/prism are singleton modules)
const $b394a85de6e9d3f2$var$generator = (options)=>{
    const { loader: loader } = options;
    // eslint-disable-next-line @repo/internal/react/no-class-components
    class AsyncHighlighter extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent {
        static{
            this.astGenerator = null;
        }
        static{
            this.highlightInstance = (0, $5Fzqn.default);
        }
        // Useful in tests
        static preload() {
            return AsyncHighlighter.loadAstGenerator();
        }
        static loadAstGenerator() {
            AsyncHighlighter.astGeneratorPromise = loader().then((astGenerator)=>{
                AsyncHighlighter.astGenerator = astGenerator;
                return astGenerator;
            });
            return AsyncHighlighter.astGeneratorPromise;
        }
        componentDidMount() {
            if (!AsyncHighlighter.astGeneratorPromise) AsyncHighlighter.loadAstGenerator();
            if (!AsyncHighlighter.astGenerator && AsyncHighlighter.astGeneratorPromise) AsyncHighlighter.astGeneratorPromise.then(()=>{
                this.forceUpdate();
            });
        }
        render() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(AsyncHighlighter.highlightInstance, {
                ...this.props,
                astGenerator: AsyncHighlighter.astGenerator
            });
        }
    }
    return AsyncHighlighter;
};

const $b394a85de6e9d3f2$var$asyncGenerator = $b394a85de6e9d3f2$var$generator({
    loader: ()=>(parcelRequire("k1PfD")).then((module)=>{
            // Webpack 3 returns module.exports as default as module, but webpack 4 returns module.exports as module.default
            return module.default || module;
        })
});
var $b394a85de6e9d3f2$export$2e2bcd8739ae039 = $b394a85de6e9d3f2$var$asyncGenerator;

});
parcelRegister("5Fzqn", function(module, exports) {

$parcel$export(module.exports, "default", () => $14521267449ceba9$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3Pfms = parcelRequire("3Pfms");

var $6yQup = parcelRequire("6yQup");
/**
 * Takes in a code string and (in the default behaviour):
 * - Uses refractor to turn it into a tree structure with highlighting metadata
 * - Collapses this tree into lines for a renderer
 * - Passes these lines to a React renderer
 *
 * In future, the final step could have a custom renderer.
 */ const $14521267449ceba9$var$Highlight = /*#__PURE__*/ (0, $eUqFw.memo)(function Highlight({ language: language = 'text', testId: testId, text: text = '', codeTagProps: codeTagProps = {
    className: `language-${language}`
}, showLineNumbers: showLineNumbers = false, firstLineNumber: firstLineNumber = 1, shouldCreateParentElementForLines: shouldCreateParentElementForLines = false, shouldWrapLongLines: shouldWrapLongLines = false, lineProps: lineProps = {}, codeBidiWarnings: codeBidiWarnings, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled, astGenerator: astGenerator = null, ...rest }) {
    // TODO maybe we call this code or text everywhere; for now we match the API in
    // @atlaskit/codeblock
    const code = text;
    const generatorClassName = 'prismjs';
    const containerProps = {
        ...rest,
        'data-testid': testId,
        className: rest.className ? `${generatorClassName} ${rest.className}` : generatorClassName
    };
    if (shouldWrapLongLines) codeTagProps.style = {
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word'
    };
    else codeTagProps.style = {
        whiteSpace: 'pre'
    };
    const codeBidiWarningConfig = {
        codeBidiWarnings: codeBidiWarnings,
        codeBidiWarningLabel: codeBidiWarningLabel,
        codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled
    };
    // Tree + logic into rows
    const rows = (0, $3Pfms.default)({
        astGenerator: astGenerator,
        code: code,
        language: language,
        shouldCreateParentElementForLines: shouldCreateParentElementForLines || !!shouldWrapLongLines,
        lineProps: lineProps,
        showLineNumbers: showLineNumbers,
        firstLineNumber: firstLineNumber
    });
    // Rows + logic into a renderer
    return (0, $6yQup.default)({
        containerProps: containerProps,
        codeTagProps: codeTagProps,
        rows: rows,
        codeBidiWarningConfig: codeBidiWarningConfig
    });
});
var $14521267449ceba9$export$2e2bcd8739ae039 = $14521267449ceba9$var$Highlight;

});
parcelRegister("3Pfms", function(module, exports) {

$parcel$export(module.exports, "default", () => $40249bc820e84d83$export$2e2bcd8739ae039);

var $1mez5 = parcelRequire("1mez5");

var $bHe2D = parcelRequire("bHe2D");

var $dKxtj = parcelRequire("dKxtj");

var $fpQsz = parcelRequire("fpQsz");
const $40249bc820e84d83$var$newLineRegex = /\n/g;
function $40249bc820e84d83$var$getNewLines(str) {
    return str.match($40249bc820e84d83$var$newLineRegex);
}
function $40249bc820e84d83$export$2e2bcd8739ae039({ astGenerator: astGenerator, code: code, language: language, shouldCreateParentElementForLines: shouldCreateParentElementForLines, lineProps: lineProps, showLineNumbers: showLineNumbers, firstLineNumber: firstLineNumber = 1 }) {
    const codeTree = (0, $fpQsz.default)(language, code, astGenerator);
    const startingLineNumber = firstLineNumber > 0 ? firstLineNumber : 1;
    const createLine = (0, $1mez5.default)(lineProps, shouldCreateParentElementForLines, showLineNumbers);
    const newTree = [];
    let lastLineBreakIndex = -1;
    let index = 0;
    // Seems odd we flatten the tree immediately - what work could we do on it more performantly than on the lines?
    const tree = (0, $dKxtj.default)(codeTree);
    while(index < tree.length){
        const testNode = tree[index];
        if (testNode.type === 'text') {
            index++;
            continue;
        }
        const node = testNode;
        const firstChildNode = node.children[0];
        if (firstChildNode.type === 'text') {
            const { value: value } = firstChildNode;
            const newLines = $40249bc820e84d83$var$getNewLines(value);
            if (newLines) {
                const splitValue = value.split('\n');
                splitValue.forEach((text, i)=>{
                    const lineNumber = newTree.length + startingLineNumber;
                    const newChild = {
                        type: 'text',
                        value: `${text}\n`
                    };
                    // if it's the first line
                    if (i === 0) {
                        const children = tree.slice(lastLineBreakIndex + 1, index).concat((0, $bHe2D.default)({
                            children: [
                                newChild
                            ],
                            className: node.properties.className,
                            lineNumber: lineNumber
                        }));
                        const line = createLine(children, lineNumber);
                        newTree.push(line);
                    // if it's the last line
                    } else if (i === splitValue.length - 1) {
                        const nextNode = tree[index + 1];
                        const stringChild = nextNode && nextNode.children && nextNode.children[0];
                        // Similar to newChild above, but no newline
                        const lastLineInPreviousSpan = {
                            type: 'text',
                            value: `${text}`
                        };
                        if (stringChild) {
                            const newElem = (0, $bHe2D.default)({
                                children: [
                                    lastLineInPreviousSpan
                                ],
                                className: node.properties.className,
                                lineNumber: lineNumber
                            });
                            tree.splice(index + 1, 0, newElem);
                        } else {
                            const children = [
                                lastLineInPreviousSpan
                            ];
                            const line = createLine(children, lineNumber, node.properties.className);
                            newTree.push(line);
                        }
                    // if it's neither the first nor the last line
                    } else {
                        const children = [
                            newChild
                        ];
                        const line = createLine(children, lineNumber, node.properties.className);
                        newTree.push(line);
                    }
                });
                lastLineBreakIndex = index;
            }
        }
        index++;
    }
    if (lastLineBreakIndex !== tree.length - 1) {
        const children = tree.slice(lastLineBreakIndex + 1, tree.length);
        if (children && children.length) {
            const lineNumber = newTree.length + startingLineNumber;
            const line = createLine(children, lineNumber);
            newTree.push(line);
        }
    }
    if (shouldCreateParentElementForLines) return newTree;
    // If shouldCreateParentElementForLines was off, we still have a tree structure we need to flatten
    // We have (RefractorNode | RefractorNode[])[] but need RefractorNode[]
    // This seems like a code smell to review
    return newTree.flat(1);
}

});
parcelRegister("1mez5", function(module, exports) {

$parcel$export(module.exports, "default", () => $c10f625ec24e7112$export$2e2bcd8739ae039);

var $bHe2D = parcelRequire("bHe2D");

var $7S3qr = parcelRequire("7S3qr");
function $c10f625ec24e7112$var$createLineGenerator(lineProps, shouldCreateParentElementForLines, showLineNumbers) {
    return (children, lineNumber, className = [])=>{
        // Needed for more complex line creation
        if (shouldCreateParentElementForLines || className.length > 0) return (0, $bHe2D.default)({
            children: children,
            lineNumber: lineNumber,
            showLineNumbers: showLineNumbers,
            lineProps: lineProps,
            className: className
        });
        else {
            // Simple line creation without the bells and whistles
            if (showLineNumbers && lineNumber) children.unshift((0, $7S3qr.default)(lineNumber));
            return children;
        }
    };
}
var $c10f625ec24e7112$export$2e2bcd8739ae039 = $c10f625ec24e7112$var$createLineGenerator;

});
parcelRegister("bHe2D", function(module, exports) {

$parcel$export(module.exports, "default", () => $661388ed7ada3799$export$2e2bcd8739ae039);

var $7S3qr = parcelRequire("7S3qr");
function $661388ed7ada3799$export$2e2bcd8739ae039({ children: children, lineNumber: lineNumber, showLineNumbers: showLineNumbers, lineProps: lineProps = {}, className: className = [] }) {
    const propsPassedInFromCodeBlock = typeof lineProps === 'function' ? lineProps(lineNumber) : lineProps;
    const properties = {
        ...propsPassedInFromCodeBlock,
        className: className
    };
    let currentChildren = children;
    if (lineNumber && showLineNumbers) {
        // When syntax highlighting is NOT turned on, the entire LOC is just a single
        // child. We can then happily create the line number and the LOC as siblings...
        if (currentChildren.length === 1) currentChildren = [
            (0, $7S3qr.default)(lineNumber),
            ...currentChildren
        ];
        else // ... However, when syntax highlighting IS on, a span is created for each
        // tokenised node in the AST (eg. <span>import</span><span>React</span>).
        // When shouldWrapLongLines is true, the row becomes `display: flex` and
        // forces all its children to be equal height. This can be a source of
        // visual bugs where a LOC is broken up weirdly into segments.
        //
        //  +---------------------------------------+
        //  | row                                   |
        //  |  +----+ +-------+ +--------+ +------+ |
        //  |  |line| |key    | |keywords| |key   | |
        //  |  |no. | |word   | |        | |word  | |
        //  |  |    | |       | |        | |      | |
        //  |  +----+ +-------+ +--------+ +------+ |
        //  +---------------------------------------+
        //
        // Nesting the children one layer deeper (i.e. creating an extra span)
        // ensures that the line number and the ENTIRE line of code are aligned by
        // the parent flexbox (the row).
        //
        //  +---------------------------------------------+
        //  | row                                         |
        //  | +----+  +--------------------------------+  |
        //  | |line|  | extra span we are creating     |  |
        //  | |no. |  |  +-------+ +--------+ +------+ |  |
        //  | |    |  |  |key    | |keywords| |key   | |  |
        //  | |    |  |  |word   | |        | |word  | |  |
        //  | |    |  |  |       | |        | |      | |  |
        //  | |    |  |  +-------+ +--------+ +------+ |  |
        //  | +----+  +--------------------------------+  |
        //  +---------------------------------------------+
        //
        currentChildren = [
            (0, $7S3qr.default)(lineNumber),
            {
                type: 'element',
                tagName: 'span',
                properties: {
                    className: []
                },
                children: currentChildren
            }
        ];
    }
    return {
        type: 'element',
        tagName: 'span',
        properties: properties,
        children: currentChildren
    };
}

});
parcelRegister("7S3qr", function(module, exports) {

$parcel$export(module.exports, "default", () => $315f37b7540047ba$export$2e2bcd8739ae039);
function $315f37b7540047ba$export$2e2bcd8739ae039(lineNumber) {
    return {
        type: 'element',
        tagName: 'span',
        properties: {
            key: `line-number--${lineNumber}`,
            className: [
                'comment',
                'linenumber',
                'ds-line-number'
            ],
            // We're placing the lineNumber in a data-attr on an empty span (hence the
            // empty children array below). This allows CodeBlock to use CSS to
            // generate the content in a pseudo-element, which is a fix for a bug
            // where line numbers were being copied (CSS content can't be copied)
            // https://product-fabric.atlassian.net/browse/DSP-2729
            'data-ds--line-number': lineNumber
        },
        children: []
    };
}

});



parcelRegister("dKxtj", function(module, exports) {

$parcel$export(module.exports, "default", () => $856ff78e7b2483ab$export$2e2bcd8739ae039);

var $bHe2D = parcelRequire("bHe2D");
function $856ff78e7b2483ab$export$2e2bcd8739ae039(tree, offset = 0, className = []) {
    let newTree = [];
    for(let i = 0; i < tree.length; i++){
        const node = tree[i];
        if (node.type === 'text') newTree.push((0, $bHe2D.default)({
            children: [
                node
            ],
            lineNumber: offset,
            className: className
        }));
        else if (node.children) {
            const classNames = className.concat(node.properties.className || []);
            $856ff78e7b2483ab$export$2e2bcd8739ae039(node.children, offset + 1, classNames).forEach((i)=>newTree.push(i));
        }
    }
    return newTree;
}

});

parcelRegister("fpQsz", function(module, exports) {

$parcel$export(module.exports, "default", () => $bbf79b48b49dc459$export$2e2bcd8739ae039);
function $bbf79b48b49dc459$export$2e2bcd8739ae039(language, code, astGenerator) {
    if (language === 'text' || !astGenerator) return [
        {
            type: 'text',
            value: code
        }
    ];
    try {
        return astGenerator.highlight(code, language);
    } catch (e) {
        return [
            {
                type: 'text',
                value: code
            }
        ];
    }
}

});


parcelRegister("6yQup", function(module, exports) {

$parcel$export(module.exports, "default", () => $04c0181fc0427ebd$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $gZrIi = parcelRequire("gZrIi");
function $04c0181fc0427ebd$export$2e2bcd8739ae039({ containerProps: containerProps, codeTagProps: codeTagProps, rows: rows, codeBidiWarningConfig: codeBidiWarningConfig }) {
    const renderedRows = rows.map((node, i)=>(0, $gZrIi.default)({
            node: node,
            codeBidiWarningConfig: codeBidiWarningConfig,
            key: `code-segment${i}`
        }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", containerProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("code", codeTagProps, renderedRows));
}

});
parcelRegister("gZrIi", function(module, exports) {

$parcel$export(module.exports, "default", () => $b67cbca33ec2bd81$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hve4P = parcelRequire("hve4P");

var $hyA5S = parcelRequire("hyA5S");

var $42VJr = parcelRequire("42VJr");
function $b67cbca33ec2bd81$var$createClassNameString(classNames) {
    return classNames ? classNames.join(' ') : '';
}
function $b67cbca33ec2bd81$export$2e2bcd8739ae039({ node: node, codeBidiWarningConfig: codeBidiWarningConfig, key: key }) {
    if (node.type === 'text') {
        const { value: value } = node;
        // occasionally a numeric value is passed when the type is text
        const textValue = `${value}`;
        if (codeBidiWarningConfig.codeBidiWarnings) {
            const decorated = (0, $hyA5S.default)(textValue, ({ bidiCharacter: bidiCharacter, index: index })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hve4P.default), {
                    bidiCharacter: bidiCharacter,
                    key: index,
                    label: codeBidiWarningConfig.codeBidiWarningLabel,
                    tooltipEnabled: codeBidiWarningConfig.codeBidiWarningTooltipEnabled
                }));
            return decorated;
        }
        return textValue;
    } else {
        const { properties: properties, tagName: tagName } = node;
        const childrenCreator = (0, $42VJr.default)(codeBidiWarningConfig);
        const props = {
            ...properties,
            className: $b67cbca33ec2bd81$var$createClassNameString(properties.className)
        };
        const children = childrenCreator(node.children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(tagName, {
            key: key,
            ...props
        }, children);
    }
}

});
parcelRegister("hve4P", function(module, exports) {

$parcel$export(module.exports, "default", () => $0cee3a28ff2903e3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8cU5f = parcelRequire("8cU5f");

var $hqCgH = parcelRequire("hqCgH");
function $0cee3a28ff2903e3$export$2e2bcd8739ae039({ testId: testId, bidiCharacter: bidiCharacter, skipChildren: skipChildren, tooltipEnabled: tooltipEnabled, label: label = 'Bidirectional characters change the order that text is rendered. This could be used to obscure malicious code.' }) {
    if (tooltipEnabled) return(// Following patches, this should be updated to use the render props signature which will provide aria attributes.
    // Note: this should be tested, as initial testing did not see attributes work with current tooltip implementation.
    // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: label,
        tag: $0cee3a28ff2903e3$var$CustomizedTagWithRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hqCgH.Decorator), {
        testId: testId,
        bidiCharacter: bidiCharacter
    }, skipChildren ? null : bidiCharacter)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hqCgH.Decorator), {
        testId: testId,
        bidiCharacter: bidiCharacter
    }, skipChildren ? null : bidiCharacter);
}
const $0cee3a28ff2903e3$var$CustomizedTagWithRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef((props, ref)=>{
    const { children: children, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        ...rest,
        ref: ref
    }, children);
});

});
parcelRegister("hqCgH", function(module, exports) {

$parcel$export(module.exports, "Decorator", () => $bffbd99dc2ca2fb8$export$a592b67c93d52467);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");


var $lkPEe = parcelRequire("lkPEe");
const $bffbd99dc2ca2fb8$var$decoration = /*#__PURE__*/ (0, $byn9U.css)({
    // Required as otherwise the following bidi characters cause the span
    // to not receive hover events.
    //
    // U+2066 LEFT-TO-RIGHT ISOLATE (when using pseudo element before)
    // U+202E RIGHT-TO-LEFT OVERRIDE' (when using pseudo element after)
    position: 'relative',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':before': {
        display: 'inline-flex',
        padding: `${"var(--ds-space-0, 0px)"} ${"var(--ds-space-050, 4px)"}`,
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'row',
        background: `var(--ds-background-warning, ${(0, $73a5c9d720aa66e1$export$41060a744ab0b7ae)})`,
        color: "var(--ds-text-warning, #7F5F01)",
        content: '"<"attr(data-bidi-character-code)">"',
        fontSize: '14px',
        fontStyle: 'normal',
        lineHeight: '18px',
        /**
     * Ensures the decoration receives pointer events when it occurs with
     * an ancestor that disables them.
     */ pointerEvents: 'auto'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':hover:before': {
        background: `var(--ds-background-warning-hovered, ${(0, $73a5c9d720aa66e1$export$41060a744ab0b7ae)})`,
        color: "var(--ds-text-warning, #533F04)"
    }
});
function $bffbd99dc2ca2fb8$export$a592b67c93d52467({ bidiCharacter: bidiCharacter, children: children, testId: testId }) {
    const bidiCharacterCode = $bffbd99dc2ca2fb8$var$getBidiCharacterCode(bidiCharacter);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $bffbd99dc2ca2fb8$var$decoration,
        "data-testid": testId,
        "data-bidi-character-code": bidiCharacterCode,
        // This is set to true so that the content is not read out by
        // screen readers as the content includes angle brackets for
        // visual decoration purposes.
        // We use a visually hidden `mark` element below for screen readers
        "aria-hidden": "true"
    }, children), /*#__PURE__*/ (0, $byn9U.jsx)((0, $lkPEe.default), {
        testId: testId && `${testId}--visually-hidden`
    }, /*#__PURE__*/ (0, $byn9U.jsx)("mark", null, bidiCharacterCode)));
}
function $bffbd99dc2ca2fb8$var$getBidiCharacterCode(bidiCharacter) {
    const bidiCharacterCode = bidiCharacter.codePointAt(0)?.toString(16);
    return `U+${bidiCharacterCode}`;
}

});


parcelRegister("hyA5S", function(module, exports) {

$parcel$export(module.exports, "default", () => $d4a6695c0dcb062d$export$2e2bcd8739ae039);
const $d4a6695c0dcb062d$export$ecb256e6a1f5ee7e = /[\u202A-\u202E\u2066-\u2069]/g;
function $d4a6695c0dcb062d$export$2e2bcd8739ae039(originalText, decorate) {
    const matches = [
        ...originalText.matchAll($d4a6695c0dcb062d$export$ecb256e6a1f5ee7e)
    ];
    if (matches.length === 0) // No matches encountered, so we return the originalText value
    return originalText;
    let children = [];
    let mappedTo = 0;
    for (const match of matches){
        if (mappedTo !== match.index) // There were unmatched characters prior to this match which haven't been
        // mapped to the children.
        // Add them as plain text.
        children.push(originalText.substring(mappedTo, match.index));
        children.push(decorate({
            bidiCharacter: match[0],
            index: match.index
        }));
        // While index is guaranteed to be present, it needs to be asserted due
        // to a limitation of typescripts regex handling
        //
        // https://github.com/microsoft/TypeScript/issues/36788
        // Decorate bidi character
        mappedTo = match.index + match[0].length;
    }
    if (mappedTo !== originalText.length) // There is text following the final match, which needs to be mapped
    // to the children.
    // Added as plain text.
    children.push(originalText.substring(mappedTo, originalText.length));
    // return the mapped children with decorated bidi characters
    return children;
}

});

parcelRegister("42VJr", function(module, exports) {

$parcel$export(module.exports, "default", () => $78b27f2d2ac6b831$export$2e2bcd8739ae039);

var $gZrIi = parcelRequire("gZrIi");
function $78b27f2d2ac6b831$export$2e2bcd8739ae039(codeBidiWarningConfig) {
    let childrenCount = 0;
    return (children)=>{
        childrenCount += 1;
        return children.map((child, i)=>(0, $gZrIi.default)({
                node: child,
                codeBidiWarningConfig: codeBidiWarningConfig,
                key: `code-segment-${childrenCount}-${i}`
            }));
    };
}

});




parcelRegister("k1PfD", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("ecid1").then(()=>parcelRequire('4PVR2'));

});




parcelRegister("1jreh", function(module, exports) {

$parcel$export(module.exports, "CopyAction", () => $7631ef2d4306fe21$export$958df07cbf9735fc);
$parcel$export(module.exports, "ActionContainer", () => $7631ef2d4306fe21$export$37ab3bdebc286ca);

var $eUqFw = parcelRequire("eUqFw");

var $bLFgh = parcelRequire("bLFgh");

var $gAbev = parcelRequire("gAbev");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $jMP2a = parcelRequire("jMP2a");

var $47EAr = parcelRequire("47EAr");
const $7631ef2d4306fe21$export$2ce9877c9c1aa16 = {
    PROMPT: 'Copy',
    SUCCESS: 'Copied!',
    FAILURE: 'Copy to clipboard failed'
};
const $7631ef2d4306fe21$export$958df07cbf9735fc = ({ source: source, actionSubjectId: actionSubjectId })=>{
    const [tooltipMessage, setTooltipMessage] = (0, $eUqFw.useState)($7631ef2d4306fe21$export$2ce9877c9c1aa16.PROMPT);
    const handleSuccess = (0, $eUqFw.useCallback)(()=>{
        setTooltipMessage($7631ef2d4306fe21$export$2ce9877c9c1aa16.SUCCESS);
    }, [
        setTooltipMessage
    ]);
    const handleError = (0, $eUqFw.useCallback)(()=>{
        setTooltipMessage($7631ef2d4306fe21$export$2ce9877c9c1aa16.FAILURE);
    }, [
        setTooltipMessage
    ]);
    const writeToClipboard = (0, $eUqFw.useCallback)((_, analyticsEvent)=>{
        actionSubjectId && (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'clicked button', actionSubjectId);
        navigator.clipboard.writeText(source).then(handleSuccess, handleError);
    }, [
        source,
        handleSuccess,
        handleError,
        actionSubjectId
    ]);
    const resetMessage = (0, $eUqFw.useCallback)(()=>{
        setTooltipMessage($7631ef2d4306fe21$export$2ce9877c9c1aa16.PROMPT);
    }, [
        setTooltipMessage
    ]);
    function shouldRender() {
        if (typeof document !== 'undefined') return Boolean(navigator?.clipboard?.writeText);
    }
    return shouldRender() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $47EAr.Action), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gAbev))),
        label: tooltipMessage,
        onClick: writeToClipboard,
        onMouseOver: resetMessage,
        onFocus: resetMessage,
        "aria-live": "assertive",
        "aria-atomic": "true",
        name: "Copy"
    }) : null;
};
const $7631ef2d4306fe21$var$stopPropagation = (event)=>event.stopPropagation();
const $7631ef2d4306fe21$export$37ab3bdebc286ca = ({ children: children })=>/**
	 * This element uses an `onMouseDown` to block event propagation
	 * to its parent but is not itself interactive.
	 */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $7631ef2d4306fe21$var$absolutePositionWrapperStyles,
        onMouseDown: $7631ef2d4306fe21$var$stopPropagation
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bLFgh.default), {
        label: "actions"
    }, children));
const $7631ef2d4306fe21$var$absolutePositionWrapperStyles = (0, $1ZAYh.xcss)({
    position: 'absolute',
    top: 'space.0',
    right: 'space.0',
    padding: 'space.050',
    zIndex: 'flag'
});

});
parcelRegister("gAbev", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::70983202358e6c01e52ccf3643b5f2a9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c128b8c06c1cce5c$var$_react = $c128b8c06c1cce5c$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $c128b8c06c1cce5c$var$_copy = $c128b8c06c1cce5c$var$_interopRequireDefault((parcelRequire("dBCpP")));

var $c128b8c06c1cce5c$var$_copy2 = $c128b8c06c1cce5c$var$_interopRequireDefault((parcelRequire("dmCPj")));
function $c128b8c06c1cce5c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for CopyIcon.
 * This component is CopyIcon, with `UNSAFE_fallbackIcon` set to "CopyIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for copying data such as text, code or other objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c128b8c06c1cce5c$var$CopyIcon = (props)=>/*#__PURE__*/ $c128b8c06c1cce5c$var$_react.default.createElement($c128b8c06c1cce5c$var$_copy.default, Object.assign({
        LEGACY_fallbackIcon: $c128b8c06c1cce5c$var$_copy2.default
    }, props));
$c128b8c06c1cce5c$var$CopyIcon.Name = 'CopyIconMigration';
var $c128b8c06c1cce5c$var$_default = module.exports.default = $c128b8c06c1cce5c$var$CopyIcon;

});
parcelRegister("dBCpP", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cb7c6c8cdb896d771e123a497630ca2d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9e7c879c9eefdea2$var$_react = $9e7c879c9eefdea2$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $9e7c879c9eefdea2$var$_UNSAFE_baseNew = $9e7c879c9eefdea2$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $9e7c879c9eefdea2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Copy".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for copying data such as text, code or other objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9e7c879c9eefdea2$var$CopyIcon = (props)=>/*#__PURE__*/ $9e7c879c9eefdea2$var$_react.default.createElement($9e7c879c9eefdea2$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M1.75 3c0-.69.56-1.25 1.25-1.25h8c.69 0 1.25.56 1.25 1.25v8c0 .69-.56 1.25-1.25 1.25H3c-.69 0-1.25-.56-1.25-1.25z"/><path stroke="currentcolor" stroke-width="1.5" d="M6 15.25h6.75a2.5 2.5 0 0 0 2.5-2.5V6"/>`
    }, props));
$9e7c879c9eefdea2$var$CopyIcon.displayName = 'CopyIcon';
var $9e7c879c9eefdea2$var$_default = module.exports.default = $9e7c879c9eefdea2$var$CopyIcon;

});

parcelRegister("dmCPj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9bab72963b78cefe$var$_react = $9bab72963b78cefe$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $9bab72963b78cefe$var$_copy = $9bab72963b78cefe$var$_interopRequireDefault((parcelRequire("dBCpP")));
function $9bab72963b78cefe$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $9bab72963b78cefe$var$CopyIcon = (props)=>/*#__PURE__*/ $9bab72963b78cefe$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M10 19h8V8h-8zM8 7.992C8 6.892 8.902 6 10.009 6h7.982C19.101 6 20 6.893 20 7.992v11.016c0 1.1-.902 1.992-2.009 1.992H10.01A2 2 0 0 1 8 19.008z"/><path d="M5 16V4.992C5 3.892 5.902 3 7.009 3H15v13zm2 0h8V5H7z"/></g></svg>`
    }, props, {
        newIcon: $9bab72963b78cefe$var$_copy.default
    }));
$9bab72963b78cefe$var$CopyIcon.displayName = 'CopyIcon';
var $9bab72963b78cefe$var$_default = module.exports.default = $9bab72963b78cefe$var$CopyIcon;

});


parcelRegister("47EAr", function(module, exports) {

$parcel$export(module.exports, "Action", () => $9556d5d1cb56e174$export$e19cd5f9376f8cee);

var $eUqFw = parcelRequire("eUqFw");

var $j9fWg = parcelRequire("j9fWg");

var $8cU5f = parcelRequire("8cU5f");
const $9556d5d1cb56e174$export$e19cd5f9376f8cee = ({ icon: icon, label: label, tooltipLabel: tooltipLabel, isLoading: isLoading, ...buttonProps })=>{
    const updateTooltip = (0, $eUqFw.useRef)();
    (0, $eUqFw.useLayoutEffect)(()=>{
        updateTooltip.current?.();
    }, [
        tooltipLabel,
        label
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: ({ update: update })=>{
            updateTooltip.current = update;
            return tooltipLabel || label;
        },
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j9fWg.default), {
        isLoading: isLoading,
        appearance: "subtle",
        icon: icon,
        label: label,
        spacing: "compact",
        ...buttonProps
    }));
};

});




parcelRegister("1YNHg", function(module, exports) {

$parcel$export(module.exports, "JiraCommonFlag", () => $115f5e3393fc07fb$export$1d9a3324fc0eb52);

var $eUqFw = parcelRequire("eUqFw");

var $jGBLd = parcelRequire("jGBLd");

var $1ojp3 = parcelRequire("1ojp3");

var $grBG3 = parcelRequire("grBG3");
const $115f5e3393fc07fb$export$1d9a3324fc0eb52 = (props)=>{
    if ((0, $jGBLd.shouldBeChoreographed)(props)) {
        const { messageType: messageType, ...rest } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1ojp3.ChoreographerCommonFlag), rest);
    }
    const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $grBG3.default), rest);
};

});
parcelRegister("jGBLd", function(module, exports) {

$parcel$export(module.exports, "shouldBeChoreographed", () => $38eaf8660dcaa871$export$a8ba9111c7eec9ac);
$parcel$export(module.exports, "environmentToEnvType", () => $38eaf8660dcaa871$export$e2cf19200849be9e);

var $1C9jQ = parcelRequire("1C9jQ");

var $EbGpR = parcelRequire("EbGpR");
function $38eaf8660dcaa871$export$a8ba9111c7eec9ac(props) {
    return !!props?.messageType && (0, $EbGpR.IntegratedChoreographerMessageTypesEnum).includes(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    props.messageType);
}
function $38eaf8660dcaa871$export$e2cf19200849be9e(environment) {
    switch(environment){
        case 'dev':
            return (0, $1C9jQ.envType).DEV;
        case 'staging':
            return (0, $1C9jQ.envType).STAGING;
        case 'prod':
            return (0, $1C9jQ.envType).PROD;
        default:
            return (0, $1C9jQ.envType).LOCAL;
    }
}

});
parcelRegister("EbGpR", function(module, exports) {

$parcel$export(module.exports, "IntegratedChoreographerMessageTypesEnum", () => $e5c6b031155cf9c2$export$dbe9e38c9d6f26d0);
const $e5c6b031155cf9c2$export$94e85cf3348f045a = {
    ENGAGEMENT: 'engagement',
    MARKETING: 'marketing',
    TRANSACTIONAL: 'transactional'
};
const $e5c6b031155cf9c2$export$dbe9e38c9d6f26d0 = [
    $e5c6b031155cf9c2$export$94e85cf3348f045a.ENGAGEMENT,
    $e5c6b031155cf9c2$export$94e85cf3348f045a.MARKETING
];

});


parcelRegister("1ojp3", function(module, exports) {

$parcel$export(module.exports, "ChoreographerCommonFlag", () => $cf99a705c3566f5a$export$ef12cdd486f28a7a);

var $kytz8 = parcelRequire("kytz8");

var $grBG3 = parcelRequire("grBG3");
const $cf99a705c3566f5a$export$ef12cdd486f28a7a = (0, $kytz8.withChoreographedRender)((0, $grBG3.default));

});
parcelRegister("kytz8", function(module, exports) {

$parcel$export(module.exports, "withChoreographedRender", () => $d60c6f7c92c4fa11$export$c1160fdac17030e);

var $eUqFw = parcelRequire("eUqFw");

var $6uNFR = parcelRequire("6uNFR");
function $d60c6f7c92c4fa11$export$c1160fdac17030e(Component, options) {
    function ChoreographedComponent({ messageId: messageId, onMessageDisposition: onMessageDisposition, ...props }) {
        const shouldRender = (0, $6uNFR.useChoreographedRender)({
            messageId: messageId,
            onMessageDisposition: onMessageDisposition
        });
        if (shouldRender) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, props);
        if (options && options.toggleableProp) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const toggleableComponentProps = {
                ...props,
                [options.toggleableProp]: false
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, toggleableComponentProps);
        }
        return null;
    }
    ChoreographedComponent.displayName = `Choreographed${Component.displayName ?? 'Component'}`;
    return ChoreographedComponent;
}

});
parcelRegister("6uNFR", function(module, exports) {

$parcel$export(module.exports, "getPendoPlugin", () => $dbff780bfca374d0$export$3d3a86b2d636214b);
$parcel$export(module.exports, "useChoreographer", () => $dbff780bfca374d0$export$9f0e2488ffd90f11);
$parcel$export(module.exports, "ChoreographedStatusContext", () => $dbff780bfca374d0$export$3ff96dbefca6b00d);
$parcel$export(module.exports, "useChoreographedStatusContext", () => $dbff780bfca374d0$export$2eb1efa814fe4a);
$parcel$export(module.exports, "useChoreographedRender", () => $dbff780bfca374d0$export$2cfd68294be82811);

var $eUqFw = parcelRequire("eUqFw");

var $5xY1g = parcelRequire("5xY1g");
var $awwEG = parcelRequire("awwEG");
var $67SDP = parcelRequire("67SDP");

var $6rW04 = parcelRequire("6rW04");

var $38OPi = parcelRequire("38OPi");
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $dbff780bfca374d0$var$environment = (0, $38OPi.toEnvironment)((0, $6rW04.default)('ajs-environment')) ?? 'prod';
const $dbff780bfca374d0$var$createChoreographerFactory = ()=>{
    if (false) return {
        useChoreographer: (..._)=>({
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                startMessage: ()=>Promise.resolve(''),
                // eslint-disable-next-line @typescript-eslint/no-empty-function
                stopMessage: ()=>{}
            })
    };
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $5xY1g.choreographerFactory)((0, $67SDP.ProductIds).JIRA, $dbff780bfca374d0$var$environment);
};
let $dbff780bfca374d0$var$pendoPlugin;
function $dbff780bfca374d0$export$3d3a86b2d636214b(env) {
    if (!$dbff780bfca374d0$var$pendoPlugin) $dbff780bfca374d0$var$pendoPlugin = new (0, $awwEG.PendoChoreographerPlugin)(env, {
        additionalData: {
            sourceProductId: (0, $67SDP.ProductIds).JIRA
        }
    });
    return $dbff780bfca374d0$var$pendoPlugin;
}
/**
 * Stupid hack alert: useChoreographer is throwing a TS compiler error about using MessageEventType
 * internally, and not being able to resolve that name... The usual fix for this is to add the
 * offending type to the project's exports, and then import it here so that the compiler has some
 * knowledge of what that type definition is... In this case, it doesn't seem to be working, but
 * for whatever reason, I can cast the choreographerFactory's return type using nothing more than
 * the information provided by the ReturnType<typeof choreographerFactory> type above, and then
 * define the useChoreographer type as an args list that conforms to its Parameters list, and a
 * return type that conforms to its ReturnType, and that seems to work just fine. Hopefully, somebody
 * can figure out what's going wrong here, and remove this idiocy in favor of something more sane.
 */ const { useChoreographer: $dbff780bfca374d0$export$9f0e2488ffd90f11 } = $dbff780bfca374d0$var$createChoreographerFactory();
const $dbff780bfca374d0$export$3ff96dbefca6b00d = /*#__PURE__*/ (0, $eUqFw.createContext)({
    isAlreadyChoreographedAtAncestor: false
});
const $dbff780bfca374d0$export$2eb1efa814fe4a = ()=>(0, $eUqFw.useContext)($dbff780bfca374d0$export$3ff96dbefca6b00d);
const $dbff780bfca374d0$export$2cfd68294be82811 = ({ messageId: messageId, onMessageDisposition: onMessageDisposition })=>{
    const { isAlreadyChoreographedAtAncestor: isAlreadyChoreographedAtAncestor } = $dbff780bfca374d0$export$2eb1efa814fe4a();
    const [shouldRender, setShouldRender] = (0, $eUqFw.useState)(false);
    const { startMessage: startMessage, stopMessage: stopMessage } = $dbff780bfca374d0$export$9f0e2488ffd90f11(messageId, {
        start: ()=>setShouldRender(true)
    });
    (0, $eUqFw.useEffect)(()=>{
        if (!isAlreadyChoreographedAtAncestor) {
            const startMessageAsync = async ()=>{
                const disposition = await startMessage();
                onMessageDisposition?.(disposition);
            };
            startMessageAsync();
            return ()=>{
                stopMessage();
            };
        }
    }, [
        onMessageDisposition,
        startMessage,
        stopMessage,
        isAlreadyChoreographedAtAncestor
    ]);
    return shouldRender || isAlreadyChoreographedAtAncestor;
};

});


parcelRegister("grBG3", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b2d6efb14273248$export$2e2bcd8739ae039);
/* common-flag.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $3Oaez = parcelRequire("3Oaez");
var $4GEic = parcelRequire("4GEic");

var $5JgJ2 = parcelRequire("5JgJ2");

var $dwpgR = parcelRequire("dwpgR");

var $eoOIK = parcelRequire("eoOIK");
const $6b2d6efb14273248$export$b020578ce674a70f = 'platform.ui.flags.common.ui.common-flag-v2';
/**
 * Renders a flag component with dynamic behavior, automatically choosing between auto-dismissing
 * and standard modes based on properties. It dynamically selects an appropriate icon and supports
 * internationalization and accessibility, making it versatile for various use cases.
 */ const $6b2d6efb14273248$var$CommonFlag = (props)=>{
    const { flagType: flagType, icon: icon, delayAnnouncement: delayAnnouncement, ...internalFlagProps } = props;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const StyledIcon = internalFlagProps.appearance ? (0, $dwpgR.boldIconMap)[flagType] : (0, $dwpgR.iconMap)[flagType];
    let flagElement;
    if (internalFlagProps.isAutoDismiss === true) {
        const { isAutoDismiss: isAutoDismiss, ...autoDismissFlagProps } = internalFlagProps;
        flagElement = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3Oaez.default), {
            testId: `${$6b2d6efb14273248$export$b020578ce674a70f}-auto-dismiss`,
            ...autoDismissFlagProps,
            icon: icon ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(StyledIcon, {
                label: formatMessage((0, $eoOIK.messages)[flagType])
            }) ?? null
        });
    } else {
        const { isAutoDismiss: isAutoDismiss, ...flagProps } = internalFlagProps;
        flagElement = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4GEic.default), {
            testId: $6b2d6efb14273248$export$b020578ce674a70f,
            ...flagProps,
            ...delayAnnouncement && {
                delayAnnouncement: delayAnnouncement
            },
            icon: icon ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(StyledIcon, {
                label: formatMessage((0, $eoOIK.messages)[flagType])
            }) ?? null
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6b2d6efb14273248$var$Container, {
        role: "status",
        "aria-live": "polite",
        ...internalFlagProps.testId !== undefined ? {
            'data-test-id': internalFlagProps.testId
        } : {}
    }, flagElement);
};
var $6b2d6efb14273248$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $6b2d6efb14273248$var$CommonFlag;
const $6b2d6efb14273248$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_slp31hna",
            __cmplp.className
        ])
    });
});

});
parcelRegister("dwpgR", function(module, exports) {

$parcel$export(module.exports, "iconMap", () => $eb890f2afc8b830a$export$6d49a893c897b0cc);
$parcel$export(module.exports, "boldIconMap", () => $eb890f2afc8b830a$export$6c71c95b1e390472);

var $ew0AN = parcelRequire("ew0AN");
const $eb890f2afc8b830a$export$6d49a893c897b0cc = {
    error: (0, $ew0AN.IconError),
    success: (0, $ew0AN.IconSuccess),
    info: (0, $ew0AN.IconInfo),
    warning: (0, $ew0AN.IconWarning)
};
const $eb890f2afc8b830a$export$6c71c95b1e390472 = {
    error: (0, $ew0AN.BoldIconError),
    success: (0, $ew0AN.BoldIconSuccess),
    info: (0, $ew0AN.BoldIconInfo),
    warning: (0, $ew0AN.BoldIconWarning)
};

});
parcelRegister("ew0AN", function(module, exports) {

$parcel$export(module.exports, "IconError", () => $82fb784a250c97db$export$66493327321323ad);
$parcel$export(module.exports, "IconSuccess", () => $82fb784a250c97db$export$9cae035d1b6ae1dc);
$parcel$export(module.exports, "IconInfo", () => $82fb784a250c97db$export$340bfce9b4df026b);
$parcel$export(module.exports, "IconWarning", () => $82fb784a250c97db$export$5be70e40251e6f9b);
$parcel$export(module.exports, "BoldIconError", () => $82fb784a250c97db$export$4d6c0ef1e9e095ae);
$parcel$export(module.exports, "BoldIconSuccess", () => $82fb784a250c97db$export$23fdc8fccd51d997);
$parcel$export(module.exports, "BoldIconInfo", () => $82fb784a250c97db$export$4c05116eb19cc3aa);
$parcel$export(module.exports, "BoldIconWarning", () => $82fb784a250c97db$export$522238647b7d04fc);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $aWvIp = parcelRequire("aWvIp");

var $96IgR = parcelRequire("96IgR");

var $2bv8J = parcelRequire("2bv8J");

var $5YsMl = parcelRequire("5YsMl");

const $82fb784a250c97db$export$66493327321323ad = ({ label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($82fb784a250c97db$export$8f314e512d92575f, {
        iconColor: `var(--ds-icon-danger, ${(0, $73a5c9d720aa66e1$exports).R300})`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($96IgR))), {
        label: label
    }));
const $82fb784a250c97db$export$9cae035d1b6ae1dc = ({ label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($82fb784a250c97db$export$8f314e512d92575f, {
        iconColor: `var(--ds-icon-success, ${(0, $73a5c9d720aa66e1$exports).G300})`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aWvIp))), {
        label: label
    }));
const $82fb784a250c97db$export$340bfce9b4df026b = ({ label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($82fb784a250c97db$export$8f314e512d92575f, {
        iconColor: `var(--ds-icon-discovery, ${(0, $73a5c9d720aa66e1$exports).P300})`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2bv8J))), {
        label: label
    }));
const $82fb784a250c97db$export$5be70e40251e6f9b = ({ label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($82fb784a250c97db$export$8f314e512d92575f, {
        iconColor: `var(--ds-icon-warning, ${(0, $73a5c9d720aa66e1$exports).Y300})`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5YsMl))), {
        label: label
    }));
const $82fb784a250c97db$export$4d6c0ef1e9e095ae = ({ label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($96IgR))), {
        label: label,
        secondaryColor: `var(--ds-icon-danger, ${(0, $73a5c9d720aa66e1$exports).R300})`
    });
const $82fb784a250c97db$export$23fdc8fccd51d997 = ({ label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aWvIp))), {
        label: label,
        secondaryColor: `var(--ds-icon-success, ${(0, $73a5c9d720aa66e1$exports).G300})`
    });
const $82fb784a250c97db$export$4c05116eb19cc3aa = ({ label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2bv8J))), {
        label: label,
        secondaryColor: `var(--ds-icon-discovery, ${(0, $73a5c9d720aa66e1$exports).P300})`
    });
const $82fb784a250c97db$export$522238647b7d04fc = ({ label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5YsMl))), {
        label: label,
        secondaryColor: `var(--ds-icon-warning, ${(0, $73a5c9d720aa66e1$exports).Y300})`
    });
const $82fb784a250c97db$export$8f314e512d92575f = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { iconColor: iconColor, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1weumv": (0, $9t7rW.default)(__cmplp.iconColor)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1kah",
            __cmplp.className
        ])
    });
});

});
parcelRegister("aWvIp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7f77ec2b05210607$var$_react = $7f77ec2b05210607$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $7f77ec2b05210607$var$_success = $7f77ec2b05210607$var$_interopRequireDefault((parcelRequire("50qGm")));
function $7f77ec2b05210607$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $7f77ec2b05210607$var$CheckCircleIcon = (props)=>/*#__PURE__*/ $7f77ec2b05210607$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586z"/></g></svg>`
    }, props, {
        newIcon: $7f77ec2b05210607$var$_success.default
    }));
$7f77ec2b05210607$var$CheckCircleIcon.displayName = 'CheckCircleIcon';
var $7f77ec2b05210607$var$_default = module.exports.default = $7f77ec2b05210607$var$CheckCircleIcon;

});
parcelRegister("50qGm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a280b44c69b6de4f4f93ebdb24542b07>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3a51a662974016bc$var$_react = $3a51a662974016bc$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $3a51a662974016bc$var$_UNSAFE_baseNew = $3a51a662974016bc$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $3a51a662974016bc$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Success".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single-purpose - Reserved for success section messages and form validation messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3a51a662974016bc$var$SuccessIcon = (props)=>/*#__PURE__*/ $3a51a662974016bc$var$_react.default.createElement($3a51a662974016bc$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m12.326-2.52-1.152-.96L6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0z" clip-rule="evenodd"/>`
    }, props));
$3a51a662974016bc$var$SuccessIcon.displayName = 'SuccessIcon';
var $3a51a662974016bc$var$_default = module.exports.default = $3a51a662974016bc$var$SuccessIcon;

});


parcelRegister("2bv8J", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1974c390fcca76c2$var$_react = $1974c390fcca76c2$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $1974c390fcca76c2$var$_information = $1974c390fcca76c2$var$_interopRequireDefault((parcelRequire("h6FFs")));
function $1974c390fcca76c2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $1974c390fcca76c2$var$InfoIcon = (props)=>/*#__PURE__*/ $1974c390fcca76c2$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M2 12c0 5.523 4.477 10 10 10s10-4.477 10-10S17.523 2 12 2 2 6.477 2 12"/><rect width="2" height="7" x="11" y="10" fill="inherit" rx="1"/><circle cx="12" cy="8" r="1" fill="inherit"/></g></svg>`
    }, props, {
        newIcon: $1974c390fcca76c2$var$_information.default
    }));
$1974c390fcca76c2$var$InfoIcon.displayName = 'InfoIcon';
var $1974c390fcca76c2$var$_default = module.exports.default = $1974c390fcca76c2$var$InfoIcon;

});
parcelRegister("h6FFs", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cfc592cc61140d99cb4eaed527408acf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c743518dce4b322a$var$_react = $c743518dce4b322a$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $c743518dce4b322a$var$_UNSAFE_baseNew = $c743518dce4b322a$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $c743518dce4b322a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Information".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: information state in section messages or inline messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c743518dce4b322a$var$InformationIcon = (props)=>/*#__PURE__*/ $c743518dce4b322a$var$_react.default.createElement($c743518dce4b322a$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m6.5-1.25H8a.75.75 0 0 1 .75.75v5h-1.5V8.25H6.5zM8 5.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
    }, props));
$c743518dce4b322a$var$InformationIcon.displayName = 'InformationIcon';
var $c743518dce4b322a$var$_default = module.exports.default = $c743518dce4b322a$var$InformationIcon;

});




parcelRegister("eoOIK", function(module, exports) {

$parcel$export(module.exports, "messages", () => $8485940862529e44$export$defe85febe8b728c);
// Should not remove this disabled-line and don't run eslint --fix for this file
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
const $8485940862529e44$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    error: {
        "id": "platform.flags.common.components.common-flag.error",
        "defaultMessage": "Error"
    },
    success: {
        "id": "platform.flags.common.components.common-flag.success",
        "defaultMessage": "Success"
    },
    info: {
        "id": "platform.flags.common.components.common-flag.info",
        "defaultMessage": "Information"
    },
    warning: {
        "id": "platform.flags.common.components.common-flag.warning",
        "defaultMessage": "Warning"
    }
});

});




parcelRegister("c8KxL", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b9f08ed55ceefb4$export$2e2bcd8739ae039);

var $kQ0RL = parcelRequire("kQ0RL");
var $4b9f08ed55ceefb4$export$2e2bcd8739ae039 = (0, $kQ0RL.FlagGroup);

});
parcelRegister("kQ0RL", function(module, exports) {

$parcel$export(module.exports, "CommonFlag", () => $2ffdc518941fd08c$export$13d73238a031436b);
$parcel$export(module.exports, "ErrorFlag", () => $2ffdc518941fd08c$export$518ba8e0e60f145f);
$parcel$export(module.exports, "ErrorAutoDismissFlag", () => $2ffdc518941fd08c$export$3f75672bb90a4431);
$parcel$export(module.exports, "InfoFlag", () => $2ffdc518941fd08c$export$6a55b52e74c1e48e);
$parcel$export(module.exports, "SuccessAutoDismissFlag", () => $2ffdc518941fd08c$export$74a3c0748aa31355);
$parcel$export(module.exports, "SuccessFlag", () => $2ffdc518941fd08c$export$93bd4963a1d00fd5);
$parcel$export(module.exports, "WarningFlag", () => $2ffdc518941fd08c$export$23695d8281998f27);
$parcel$export(module.exports, "FlagGroup", () => $2ffdc518941fd08c$export$a2c3479950310d7d);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $5L0Jp = parcelRequire("5L0Jp");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$ForPaintJiraCommonFlag = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("5eqyk")).then(({ JiraCommonFlag: JiraCommonFlag })=>JiraCommonFlag), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$AfterPaintJiraCommonFlag = (0, $7rh0R.lazyAfterPaint)(()=>// eslint-disable-next-line jira/import/webpack-magic-comment-entries
    (parcelRequire("5eqyk")).then(({ JiraCommonFlag: JiraCommonFlag })=>JiraCommonFlag), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
});
const $2ffdc518941fd08c$var$CommonFlagImpl = (props)=>__SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$AfterPaintJiraCommonFlag, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$ForPaintJiraCommonFlag, props);

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$ForPaintFlagGroup = (0, $7rh0R.lazyForPaint)(// eslint-disable-next-line jira/import/webpack-magic-comment-entries
()=>(parcelRequire("eWPgg")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/group-flag-v2/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$AfterPaintFlagGroup = (0, $7rh0R.lazyAfterPaint)(// eslint-disable-next-line jira/import/webpack-magic-comment-entries
()=>(parcelRequire("eWPgg")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/group-flag-v2/index.tsx"
});
const $2ffdc518941fd08c$var$FlagGroupImpl = (props)=>__SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$AfterPaintFlagGroup, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$ForPaintFlagGroup, props);
const $2ffdc518941fd08c$export$13d73238a031436b = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, props));
const $2ffdc518941fd08c$export$518ba8e0e60f145f = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "error",
        ...props
    }));
const $2ffdc518941fd08c$export$3f75672bb90a4431 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "error",
        isAutoDismiss: true,
        ...props
    }));
const $2ffdc518941fd08c$export$6a55b52e74c1e48e = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "info",
        ...props
    }));
const $2ffdc518941fd08c$export$74a3c0748aa31355 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "success",
        isAutoDismiss: true,
        ...props
    }));
const $2ffdc518941fd08c$export$93bd4963a1d00fd5 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "success",
        ...props
    }));
const $2ffdc518941fd08c$export$23695d8281998f27 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "warning",
        ...props
    }));
const $2ffdc518941fd08c$export$a2c3479950310d7d = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$FlagGroupImpl, props));

});
parcelRegister("5eqyk", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("cCYJs")
]).then(()=>parcelRequire('kbpOk'));

});

parcelRegister("eWPgg", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("hkLGi").then(()=>parcelRequire('jkRT2'));

});



parcelRegister("giAhk", function(module, exports) {

$parcel$export(module.exports, "injectIntlV2", () => $208f42a3fdc9fe2c$export$440265f0ca78e98e);

var $eUqFw = parcelRequire("eUqFw");

var $lxchL = parcelRequire("lxchL");

var $2qhQi = parcelRequire("2qhQi");

var $1IqwQ = parcelRequire("1IqwQ");
const $208f42a3fdc9fe2c$var$IntlConsumer = (0, $2qhQi.Context).Consumer;
const $208f42a3fdc9fe2c$var$isDisplayableString = (mayBeString)=>typeof mayBeString === 'string' && mayBeString !== '';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $208f42a3fdc9fe2c$var$getDisplayName(Component) {
    if ($208f42a3fdc9fe2c$var$isDisplayableString(Component.displayName)) // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'string'.
    return Component.displayName;
    if ($208f42a3fdc9fe2c$var$isDisplayableString(Component.name)) return Component.name;
    return 'Component';
}
const $208f42a3fdc9fe2c$export$440265f0ca78e98e = (WrappedComponent, options)=>{
    const { withRef: withRef = false } = options || {};
    const WithIntl = (props)=>{
        const intlRef = (0, $eUqFw.useRef)(null);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($208f42a3fdc9fe2c$var$IntlConsumer, null, (intl)=>{
            if (!intl) throw new Error('REACT_INTL_FACADE: React Intl Could not find required `intl` object');
            if (!intlRef.current) intlRef.current = {
                // Now is deprecated since version 2: https://github.com/formatjs/formatjs/issues/1409
                now: ()=>Date.now(),
                // @ts-expect-error We force v5 messages type on v2 type
                messages: intl.messages,
                locale: intl.locale,
                formats: intl.formats,
                formatDate: intl.formatDate,
                formatMessage: intl.formatMessage,
                formatHTMLMessage: (descriptor, values)=>intl.formatMessage(descriptor, values, {
                        ignoreTag: true
                    }),
                formatNumber: intl.formatNumber,
                formatRelative: (date, opts)=>{
                    const { time: time, unit: unit } = (0, $1IqwQ.getRelativeTimeAndUnit)(date);
                    return intl.formatRelativeTime(time, unit, opts);
                },
                formatPlural: intl.formatPlural,
                formatTime: intl.formatTime
            };
            return(// @ts-expect-error - TS2322 - Type 'Diff<LibraryManagedAttributes<Component, ComponentProps<Component>>, InjectIntlVoidProps> & { ...; } & { ...; }' is not assignable to type 'IntrinsicAttributes & LibraryManagedAttributes<Component, PropsWithChildren<P>>'.
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
                ...props,
                intl: intlRef.current,
                ref: withRef ? props.forwardedRef : null
            }));
        });
    };
    // Changed this display name to be capital letter to prevent snapshots from failing, here is the original: https://github.com/formatjs/formatjs/blob/main/packages/react-intl/src/components/injectIntl.tsx#L98
    WithIntl.displayName = `InjectIntl(${$208f42a3fdc9fe2c$var$getDisplayName(WrappedComponent)})`;
    WithIntl.WrappedComponent = WrappedComponent;
    if (withRef) // @ts-expect-error - TS2352 - Conversion of type 'ForwardRefExoticComponent<PropsWithoutRef<WithIntlProps<LibraryManagedAttributes<C, ComponentProps<C>>>> & RefAttributes<...>> & NonReactStatics<...>' to type 'ComponentType<WithIntlProps<LibraryManagedAttributes<C, ComponentProps<C>>>>' may be a mistake because neither type sufficiently overlaps with the other. If this was intentional, convert the expression to 'unknown' first.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, (/*@__PURE__*/$parcel$interopDefault($lxchL)))(/*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WithIntl, {
            ...props,
            forwardedRef: ref
        })), WrappedComponent);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, (/*@__PURE__*/$parcel$interopDefault($lxchL)))(WithIntl, WrappedComponent);
};

});
parcelRegister("1IqwQ", function(module, exports) {

$parcel$export(module.exports, "getRelativeTimeAndUnit", () => $6a7dda3450af4d49$export$307c4b8ee56b97bb);
$parcel$export(module.exports, "FormattedRelativeV2", () => $6a7dda3450af4d49$export$7317ee2f88fd1276);

var $eUqFw = parcelRequire("eUqFw");

var $9KU0P = parcelRequire("9KU0P");

var $8M1qS = parcelRequire("8M1qS");
const $6a7dda3450af4d49$var$getTimeInUnits = (unitValue)=>{
    const seconds = unitValue / 1000;
    const minutes = seconds / 60;
    const hours = minutes / 60;
    const days = hours / 24;
    const weeks = days / 7;
    const months = weeks / 4;
    const years = months / 12;
    return {
        seconds: seconds,
        minutes: minutes,
        hours: hours,
        days: days,
        weeks: weeks,
        months: months,
        years: years
    };
};
const $6a7dda3450af4d49$export$307c4b8ee56b97bb = (value, units)=>{
    const timeInMilliseconds = new Date(value);
    // @ts-expect-error - TS2362 - The left-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type.
    const delta = timeInMilliseconds - Date.now();
    let valueInUnit;
    if (!units) {
        const { value: time, unit: unit } = (0, $9KU0P.selectUnit)(timeInMilliseconds, new Date());
        return {
            time: time,
            unit: unit
        };
    }
    const { seconds: seconds, minutes: minutes, hours: hours, days: days, weeks: weeks, months: months, years: years } = $6a7dda3450af4d49$var$getTimeInUnits(delta);
    switch(units){
        case 'second':
            valueInUnit = seconds;
            break;
        case 'minute':
            valueInUnit = minutes;
            break;
        case 'hour':
            valueInUnit = hours;
            break;
        case 'day':
            valueInUnit = days;
            break;
        case 'week':
            valueInUnit = weeks;
            break;
        case 'month':
            valueInUnit = months;
            break;
        case 'year':
            valueInUnit = years;
            break;
        default:
            valueInUnit = 0;
            break;
    }
    return {
        time: Math.ceil(valueInUnit),
        unit: units
    };
};
const $6a7dda3450af4d49$export$7317ee2f88fd1276 = ({ value: value, units: units, children: children, style: style, format: format, updateInterval: updateInterval })=>{
    const { time: time, unit: unit } = $6a7dda3450af4d49$export$307c4b8ee56b97bb(value, units);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8M1qS.default), {
        value: time,
        unit: unit,
        numeric: style === 'numeric' ? 'always' : 'auto',
        format: format,
        updateIntervalInSeconds: updateInterval
    }, children);
};
$6a7dda3450af4d49$export$7317ee2f88fd1276.displayName = 'FormattedRelative';

});



parcelRegister("d9san", function(module, exports) {

$parcel$export(module.exports, "PropBypass", () => $68ce62dbfd3c2566$export$84bef06589f4b13a);
const $68ce62dbfd3c2566$export$84bef06589f4b13a = ({ children: children, key: key, ...props })=>children(props);

});




//# sourceMappingURL=async-flags.8c611155.js.map
